export const cities = [
  {
    id: "1",
    value: "Mumbai",
    label: "Maharashtra",
  },
  {
    id: "2",
    value: "Delhi",
    label: "Delhi",
  },
  {
    id: "3",
    value: "Bengaluru",
    label: "Karnataka",
  },
  {
    id: "4",
    value: "Ahmedabad",
    label: "Gujarat",
  },
  {
    id: "5",
    value: "Hyderabad",
    label: "Telangana",
  },
  {
    id: "6",
    value: "Chennai",
    label: "Tamil Nadu",
  },
  {
    id: "7",
    value: "Kolkata",
    label: "West Bengal",
  },
  {
    id: "8",
    value: "Pune",
    label: "Maharashtra",
  },
  {
    id: "9",
    value: "Jaipur",
    label: "Rajasthan",
  },
  {
    id: "10",
    value: "Surat",
    label: "Gujarat",
  },
  {
    id: "11",
    value: "Lucknow",
    label: "Uttar Pradesh",
  },
  {
    id: "12",
    value: "Kanpur",
    label: "Uttar Pradesh",
  },
  {
    id: "13",
    value: "Nagpur",
    label: "Maharashtra",
  },
  {
    id: "14",
    value: "Patna",
    label: "Bihar",
  },
  {
    id: "15",
    value: "Indore",
    label: "Madhya Pradesh",
  },
  {
    id: "16",
    value: "Thane",
    label: "Maharashtra",
  },
  {
    id: "17",
    value: "Bhopal",
    label: "Madhya Pradesh",
  },
  {
    id: "18",
    value: "Visakhapatnam",
    label: "Andhra Pradesh",
  },
  {
    id: "19",
    value: "Vadodara",
    label: "Gujarat",
  },
  {
    id: "20",
    value: "Firozabad",
    label: "Uttar Pradesh",
  },
  {
    id: "21",
    value: "Ludhiana",
    label: "Punjab",
  },
  {
    id: "22",
    value: "Rajkot",
    label: "Gujarat",
  },
  {
    id: "23",
    value: "Agra",
    label: "Uttar Pradesh",
  },
  {
    id: "24",
    value: "Siliguri",
    label: "West Bengal",
  },
  {
    id: "25",
    value: "Nashik",
    label: "Maharashtra",
  },
  {
    id: "26",
    value: "Faridabad",
    label: "Haryana",
  },
  {
    id: "27",
    value: "Patiala",
    label: "Punjab",
  },
  {
    id: "28",
    value: "Meerut",
    label: "Uttar Pradesh",
  },
  {
    id: "29",
    value: "Kalyan-Dombivali",
    label: "Maharashtra",
  },
  {
    id: "30",
    value: "Vasai-Virar",
    label: "Maharashtra",
  },
  {
    id: "31",
    value: "Varanasi",
    label: "Uttar Pradesh",
  },
  {
    id: "32",
    value: "Srinagar",
    label: "Jammu and Kashmir",
  },
  {
    id: "33",
    value: "Dhanbad",
    label: "Jharkhand",
  },
  {
    id: "34",
    value: "Jodhpur",
    label: "Rajasthan",
  },
  {
    id: "35",
    value: "Amritsar",
    label: "Punjab",
  },
  {
    id: "36",
    value: "Raipur",
    label: "Chhattisgarh",
  },
  {
    id: "37",
    value: "Allahabad",
    label: "Uttar Pradesh",
  },
  {
    id: "38",
    value: "Coimbatore",
    label: "Tamil Nadu",
  },
  {
    id: "39",
    value: "Jabalpur",
    label: "Madhya Pradesh",
  },
  {
    id: "40",
    value: "Gwalior",
    label: "Madhya Pradesh",
  },
  {
    id: "41",
    value: "Vijayawada",
    label: "Andhra Pradesh",
  },
  {
    id: "42",
    value: "Madurai",
    label: "Tamil Nadu",
  },
  {
    id: "43",
    value: "Guwahati",
    label: "Assam",
  },
  {
    id: "44",
    value: "Chandigarh",
    label: "Chandigarh",
  },
  {
    id: "45",
    value: "Hubli-Dharwad",
    label: "Karnataka",
  },
  {
    id: "46",
    value: "Amroha",
    label: "Uttar Pradesh",
  },
  {
    id: "47",
    value: "Moradabad",
    label: "Uttar Pradesh",
  },
  {
    id: "48",
    value: "Gurgaon",
    label: "Haryana",
  },
  {
    id: "49",
    value: "Aligarh",
    label: "Uttar Pradesh",
  },
  {
    id: "50",
    value: "Solapur",
    label: "Maharashtra",
  },
  {
    id: "51",
    value: "Ranchi",
    label: "Jharkhand",
  },
  {
    id: "52",
    value: "Jalandhar",
    label: "Punjab",
  },
  {
    id: "53",
    value: "Tiruchirappalli",
    label: "Tamil Nadu",
  },
  {
    id: "54",
    value: "Bhubaneswar",
    label: "Odisha",
  },
  {
    id: "55",
    value: "Salem",
    label: "Tamil Nadu",
  },
  {
    id: "56",
    value: "Warangal",
    label: "Telangana",
  },
  {
    id: "57",
    value: "Mira-Bhayandar",
    label: "Maharashtra",
  },
  {
    id: "58",
    value: "Thiruvananthapuram",
    label: "Kerala",
  },
  {
    id: "59",
    value: "Bhiwandi",
    label: "Maharashtra",
  },
  {
    id: "60",
    value: "Saharanpur",
    label: "Uttar Pradesh",
  },
  {
    id: "61",
    value: "Guntur",
    label: "Andhra Pradesh",
  },
  {
    id: "62",
    value: "Amravati",
    label: "Maharashtra",
  },
  {
    id: "63",
    value: "Bikaner",
    label: "Rajasthan",
  },
  {
    id: "64",
    value: "Noida",
    label: "Uttar Pradesh",
  },
  {
    id: "65",
    value: "Jamshedpur",
    label: "Jharkhand",
  },
  {
    id: "66",
    value: "Bhilai Nagar",
    label: "Chhattisgarh",
  },
  {
    id: "67",
    value: "Cuttack",
    label: "Odisha",
  },
  {
    id: "68",
    value: "Kochi",
    label: "Kerala",
  },
  {
    id: "69",
    value: "Udaipur",
    label: "Rajasthan",
  },
  {
    id: "70",
    value: "Bhavnagar",
    label: "Gujarat",
  },
  {
    id: "71",
    value: "Dehradun",
    label: "Uttarakhand",
  },
  {
    id: "72",
    value: "Asansol",
    label: "West Bengal",
  },
  {
    id: "73",
    value: "Nanded-Waghala",
    label: "Maharashtra",
  },
  {
    id: "74",
    value: "Ajmer",
    label: "Rajasthan",
  },
  {
    id: "75",
    value: "Jamnagar",
    label: "Gujarat",
  },
  {
    id: "76",
    value: "Ujjain",
    label: "Madhya Pradesh",
  },
  {
    id: "77",
    value: "Sangli",
    label: "Maharashtra",
  },
  {
    id: "78",
    value: "Loni",
    label: "Uttar Pradesh",
  },
  {
    id: "79",
    value: "Jhansi",
    label: "Uttar Pradesh",
  },
  {
    id: "80",
    value: "Pondicherry",
    label: "Puducherry",
  },
  {
    id: "81",
    value: "Nellore",
    label: "Andhra Pradesh",
  },
  {
    id: "82",
    value: "Jammu",
    label: "Jammu and Kashmir",
  },
  {
    id: "83",
    value: "Belagavi",
    label: "Karnataka",
  },
  {
    id: "84",
    value: "Raurkela",
    label: "Odisha",
  },
  {
    id: "85",
    value: "Mangaluru",
    label: "Karnataka",
  },
  {
    id: "86",
    value: "Tirunelveli",
    label: "Tamil Nadu",
  },
  {
    id: "87",
    value: "Malegaon",
    label: "Maharashtra",
  },
  {
    id: "88",
    value: "Gaya",
    label: "Bihar",
  },
  {
    id: "89",
    value: "Tiruppur",
    label: "Tamil Nadu",
  },
  {
    id: "90",
    value: "Davanagere",
    label: "Karnataka",
  },
  {
    id: "91",
    value: "Kozhikode",
    label: "Kerala",
  },
  {
    id: "92",
    value: "Akola",
    label: "Maharashtra",
  },
  {
    id: "93",
    value: "Kurnool",
    label: "Andhra Pradesh",
  },
  {
    id: "94",
    value: "Bokaro Steel City",
    label: "Jharkhand",
  },
  {
    id: "95",
    value: "Rajahmundry",
    label: "Andhra Pradesh",
  },
  {
    id: "96",
    value: "Ballari",
    label: "Karnataka",
  },
  {
    id: "97",
    value: "Agartala",
    label: "Tripura",
  },
  {
    id: "98",
    value: "Bhagalpur",
    label: "Bihar",
  },
  {
    id: "99",
    value: "Latur",
    label: "Maharashtra",
  },
  {
    id: "100",
    value: "Dhule",
    label: "Maharashtra",
  },
  {
    id: "101",
    value: "Korba",
    label: "Chhattisgarh",
  },
  {
    id: "102",
    value: "Bhilwara",
    label: "Rajasthan",
  },
  {
    id: "103",
    value: "Brahmapur",
    label: "Odisha",
  },
  {
    id: "104",
    value: "Mysore",
    label: "Karnataka",
  },
  {
    id: "105",
    value: "Muzaffarpur",
    label: "Bihar",
  },
  {
    id: "106",
    value: "Ahmednagar",
    label: "Maharashtra",
  },
  {
    id: "107",
    value: "Kollam",
    label: "Kerala",
  },
  {
    id: "108",
    value: "Raghunathganj",
    label: "West Bengal",
  },
  {
    id: "109",
    value: "Bilaspur",
    label: "Chhattisgarh",
  },
  {
    id: "110",
    value: "Shahjahanpur",
    label: "Uttar Pradesh",
  },
  {
    id: "111",
    value: "Thrissur",
    label: "Kerala",
  },
  {
    id: "112",
    value: "Alwar",
    label: "Rajasthan",
  },
  {
    id: "113",
    value: "Kakinada",
    label: "Andhra Pradesh",
  },
  {
    id: "114",
    value: "Nizamabad",
    label: "Telangana",
  },
  {
    id: "115",
    value: "Sagar",
    label: "Madhya Pradesh",
  },
  {
    id: "116",
    value: "Tumkur",
    label: "Karnataka",
  },
  {
    id: "117",
    value: "Hisar",
    label: "Haryana",
  },
  {
    id: "118",
    value: "Rohtak",
    label: "Haryana",
  },
  {
    id: "119",
    value: "Panipat",
    label: "Haryana",
  },
  {
    id: "120",
    value: "Darbhanga",
    label: "Bihar",
  },
  {
    id: "121",
    value: "Kharagpur",
    label: "West Bengal",
  },
  {
    id: "122",
    value: "Aizawl",
    label: "Mizoram",
  },
  {
    id: "123",
    value: "Ichalkaranji",
    label: "Maharashtra",
  },
  {
    id: "124",
    value: "Tirupati",
    label: "Andhra Pradesh",
  },
  {
    id: "125",
    value: "Karnal",
    label: "Haryana",
  },
  {
    id: "126",
    value: "Bathinda",
    label: "Punjab",
  },
  {
    id: "127",
    value: "Rampur",
    label: "Uttar Pradesh",
  },
  {
    id: "128",
    value: "Shivamogga",
    label: "Karnataka",
  },
  {
    id: "129",
    value: "Ratlam",
    label: "Madhya Pradesh",
  },
  {
    id: "130",
    value: "Modinagar",
    label: "Uttar Pradesh",
  },
  {
    id: "131",
    value: "Durg",
    label: "Chhattisgarh",
  },
  {
    id: "132",
    value: "Shillong",
    label: "Meghalaya",
  },
  {
    id: "133",
    value: "Imphal",
    label: "Manipur",
  },
  {
    id: "134",
    value: "Hapur",
    label: "Uttar Pradesh",
  },
  {
    id: "135",
    value: "Ranipet",
    label: "Tamil Nadu",
  },
  {
    id: "136",
    value: "Anantapur",
    label: "Andhra Pradesh",
  },
  {
    id: "137",
    value: "Arrah",
    label: "Bihar",
  },
  {
    id: "138",
    value: "Karimnagar",
    label: "Telangana",
  },
  {
    id: "139",
    value: "Parbhani",
    label: "Maharashtra",
  },
  {
    id: "140",
    value: "Etawah",
    label: "Uttar Pradesh",
  },
  {
    id: "141",
    value: "Bharatpur",
    label: "Rajasthan",
  },
  {
    id: "142",
    value: "Begusarai",
    label: "Bihar",
  },
  {
    id: "143",
    value: "New Delhi",
    label: "Delhi",
  },
  {
    id: "144",
    value: "Chhapra",
    label: "Bihar",
  },
  {
    id: "145",
    value: "Kadapa",
    label: "Andhra Pradesh",
  },
  {
    id: "146",
    value: "Ramagundam",
    label: "Telangana",
  },
  {
    id: "147",
    value: "Pali",
    label: "Rajasthan",
  },
  {
    id: "148",
    value: "Satna",
    label: "Madhya Pradesh",
  },
  {
    id: "149",
    value: "Vizianagaram",
    label: "Andhra Pradesh",
  },
  {
    id: "150",
    value: "Katihar",
    label: "Bihar",
  },
  {
    id: "151",
    value: "Hardwar",
    label: "Uttarakhand",
  },
  {
    id: "152",
    value: "Sonipat",
    label: "Haryana",
  },
  {
    id: "153",
    value: "Nagercoil",
    label: "Tamil Nadu",
  },
  {
    id: "154",
    value: "Thanjavur",
    label: "Tamil Nadu",
  },
  {
    id: "155",
    value: "Murwara (Katni)",
    label: "Madhya Pradesh",
  },
  {
    id: "156",
    value: "Naihati",
    label: "West Bengal",
  },
  {
    id: "157",
    value: "Sambhal",
    label: "Uttar Pradesh",
  },
  {
    id: "158",
    value: "Nadiad",
    label: "Gujarat",
  },
  {
    id: "159",
    value: "Yamunanagar",
    label: "Haryana",
  },
  {
    id: "160",
    value: "English Bazar",
    label: "West Bengal",
  },
  {
    id: "161",
    value: "Eluru",
    label: "Andhra Pradesh",
  },
  {
    id: "162",
    value: "Munger",
    label: "Bihar",
  },
  {
    id: "163",
    value: "Panchkula",
    label: "Haryana",
  },
  {
    id: "164",
    value: "Raayachuru",
    label: "Karnataka",
  },
  {
    id: "165",
    value: "Panvel",
    label: "Maharashtra",
  },
  {
    id: "166",
    value: "Deoghar",
    label: "Jharkhand",
  },
  {
    id: "167",
    value: "Ongole",
    label: "Andhra Pradesh",
  },
  {
    id: "168",
    value: "Nandyal",
    label: "Andhra Pradesh",
  },
  {
    id: "169",
    value: "Morena",
    label: "Madhya Pradesh",
  },
  {
    id: "170",
    value: "Bhiwani",
    label: "Haryana",
  },
  {
    id: "171",
    value: "Porbandar",
    label: "Gujarat",
  },
  {
    id: "172",
    value: "Palakkad",
    label: "Kerala",
  },
  {
    id: "173",
    value: "Anand",
    label: "Gujarat",
  },
  {
    id: "174",
    value: "Purnia",
    label: "Bihar",
  },
  {
    id: "175",
    value: "Baharampur",
    label: "West Bengal",
  },
  {
    id: "176",
    value: "Barmer",
    label: "Rajasthan",
  },
  {
    id: "177",
    value: "Morvi",
    label: "Gujarat",
  },
  {
    id: "178",
    value: "Orai",
    label: "Uttar Pradesh",
  },
  {
    id: "179",
    value: "Bahraich",
    label: "Uttar Pradesh",
  },
  {
    id: "180",
    value: "Sikar",
    label: "Rajasthan",
  },
  {
    id: "181",
    value: "Vellore",
    label: "Tamil Nadu",
  },
  {
    id: "182",
    value: "Singrauli",
    label: "Madhya Pradesh",
  },
  {
    id: "183",
    value: "Khammam",
    label: "Telangana",
  },
  {
    id: "184",
    value: "Mahesana",
    label: "Gujarat",
  },
  {
    id: "185",
    value: "Silchar",
    label: "Assam",
  },
  {
    id: "186",
    value: "Sambalpur",
    label: "Odisha",
  },
  {
    id: "187",
    value: "Rewa",
    label: "Madhya Pradesh",
  },
  {
    id: "188",
    value: "Unnao",
    label: "Uttar Pradesh",
  },
  {
    id: "189",
    value: "Hugli-Chinsurah",
    label: "West Bengal",
  },
  {
    id: "190",
    value: "Raiganj",
    label: "West Bengal",
  },
  {
    id: "191",
    value: "Phusro",
    label: "Jharkhand",
  },
  {
    id: "192",
    value: "Adityapur",
    label: "Jharkhand",
  },
  {
    id: "193",
    value: "Alappuzha",
    label: "Kerala",
  },
  {
    id: "194",
    value: "Bahadurgarh",
    label: "Haryana",
  },
  {
    id: "195",
    value: "Machilipatnam",
    label: "Andhra Pradesh",
  },
  {
    id: "196",
    value: "Rae Bareli",
    label: "Uttar Pradesh",
  },
  {
    id: "197",
    value: "Jalpaiguri",
    label: "West Bengal",
  },
  {
    id: "198",
    value: "Bharuch",
    label: "Gujarat",
  },
  {
    id: "199",
    value: "Pathankot",
    label: "Punjab",
  },
  {
    id: "200",
    value: "Hoshiarpur",
    label: "Punjab",
  },
  {
    id: "201",
    value: "Baramula",
    label: "Jammu and Kashmir",
  },
  {
    id: "202",
    value: "Adoni",
    label: "Andhra Pradesh",
  },
  {
    id: "203",
    value: "Jind",
    label: "Haryana",
  },
  {
    id: "204",
    value: "Tonk",
    label: "Rajasthan",
  },
  {
    id: "205",
    value: "Tenali",
    label: "Andhra Pradesh",
  },
  {
    id: "206",
    value: "Kancheepuram",
    label: "Tamil Nadu",
  },
  {
    id: "207",
    value: "Vapi",
    label: "Gujarat",
  },
  {
    id: "208",
    value: "Sirsa",
    label: "Haryana",
  },
  {
    id: "209",
    value: "Navsari",
    label: "Gujarat",
  },
  {
    id: "210",
    value: "Mahbubnagar",
    label: "Telangana",
  },
  {
    id: "211",
    value: "Puri",
    label: "Odisha",
  },
  {
    id: "212",
    value: "Robertson Pet",
    label: "Karnataka",
  },
  {
    id: "213",
    value: "Erode",
    label: "Tamil Nadu",
  },
  {
    id: "214",
    value: "Batala",
    label: "Punjab",
  },
  {
    id: "215",
    value: "Haldwani-cum-Kathgodam",
    label: "Uttarakhand",
  },
  {
    id: "216",
    value: "Vidisha",
    label: "Madhya Pradesh",
  },
  {
    id: "217",
    value: "Saharsa",
    label: "Bihar",
  },
  {
    id: "218",
    value: "Thanesar",
    label: "Haryana",
  },
  {
    id: "219",
    value: "Chittoor",
    label: "Andhra Pradesh",
  },
  {
    id: "220",
    value: "Veraval",
    label: "Gujarat",
  },
  {
    id: "221",
    value: "Lakhimpur",
    label: "Uttar Pradesh",
  },
  {
    id: "222",
    value: "Sitapur",
    label: "Uttar Pradesh",
  },
  {
    id: "223",
    value: "Hindupur",
    label: "Andhra Pradesh",
  },
  {
    id: "224",
    value: "Santipur",
    label: "West Bengal",
  },
  {
    id: "225",
    value: "Balurghat",
    label: "West Bengal",
  },
  {
    id: "226",
    value: "Ganjbasoda",
    label: "Madhya Pradesh",
  },
  {
    id: "227",
    value: "Moga",
    label: "Punjab",
  },
  {
    id: "228",
    value: "Proddatur",
    label: "Andhra Pradesh",
  },
  {
    id: "229",
    value: "Srinagar",
    label: "Uttarakhand",
  },
  {
    id: "230",
    value: "Medinipur",
    label: "West Bengal",
  },
  {
    id: "231",
    value: "Habra",
    label: "West Bengal",
  },
  {
    id: "232",
    value: "Sasaram",
    label: "Bihar",
  },
  {
    id: "233",
    value: "Hajipur",
    label: "Bihar",
  },
  {
    id: "234",
    value: "Bhuj",
    label: "Gujarat",
  },
  {
    id: "235",
    value: "Shivpuri",
    label: "Madhya Pradesh",
  },
  {
    id: "236",
    value: "Ranaghat",
    label: "West Bengal",
  },
  {
    id: "237",
    value: "Shimla",
    label: "Himachal Pradesh",
  },
  {
    id: "238",
    value: "Tiruvannamalai",
    label: "Tamil Nadu",
  },
  {
    id: "239",
    value: "Kaithal",
    label: "Haryana",
  },
  {
    id: "240",
    value: "Rajnandgaon",
    label: "Chhattisgarh",
  },
  {
    id: "241",
    value: "Godhra",
    label: "Gujarat",
  },
  {
    id: "242",
    value: "Hazaribag",
    label: "Jharkhand",
  },
  {
    id: "243",
    value: "Bhimavaram",
    label: "Andhra Pradesh",
  },
  {
    id: "244",
    value: "Mandsaur",
    label: "Madhya Pradesh",
  },
  {
    id: "245",
    value: "Dibrugarh",
    label: "Assam",
  },
  {
    id: "246",
    value: "Kolar",
    label: "Karnataka",
  },
  {
    id: "247",
    value: "Bankura",
    label: "West Bengal",
  },
  {
    id: "248",
    value: "Mandya",
    label: "Karnataka",
  },
  {
    id: "249",
    value: "Dehri-on-Sone",
    label: "Bihar",
  },
  {
    id: "250",
    value: "Madanapalle",
    label: "Andhra Pradesh",
  },
  {
    id: "251",
    value: "Malerkotla",
    label: "Punjab",
  },
  {
    id: "252",
    value: "Lalitpur",
    label: "Uttar Pradesh",
  },
  {
    id: "253",
    value: "Bettiah",
    label: "Bihar",
  },
  {
    id: "254",
    value: "Pollachi",
    label: "Tamil Nadu",
  },
  {
    id: "255",
    value: "Khanna",
    label: "Punjab",
  },
  {
    id: "256",
    value: "Neemuch",
    label: "Madhya Pradesh",
  },
  {
    id: "257",
    value: "Palwal",
    label: "Haryana",
  },
  {
    id: "258",
    value: "Palanpur",
    label: "Gujarat",
  },
  {
    id: "259",
    value: "Guntakal",
    label: "Andhra Pradesh",
  },
  {
    id: "260",
    value: "Nabadwip",
    label: "West Bengal",
  },
  {
    id: "261",
    value: "Udupi",
    label: "Karnataka",
  },
  {
    id: "262",
    value: "Jagdalpur",
    label: "Chhattisgarh",
  },
  {
    id: "263",
    value: "Motihari",
    label: "Bihar",
  },
  {
    id: "264",
    value: "Pilibhit",
    label: "Uttar Pradesh",
  },
  {
    id: "265",
    value: "Dimapur",
    label: "Nagaland",
  },
  {
    id: "266",
    value: "Mohali",
    label: "Punjab",
  },
  {
    id: "267",
    value: "Sadulpur",
    label: "Rajasthan",
  },
  {
    id: "268",
    value: "Rajapalayam",
    label: "Tamil Nadu",
  },
  {
    id: "269",
    value: "Dharmavaram",
    label: "Andhra Pradesh",
  },
  {
    id: "270",
    value: "Kashipur",
    label: "Uttarakhand",
  },
  {
    id: "271",
    value: "Sivakasi",
    label: "Tamil Nadu",
  },
  {
    id: "272",
    value: "Darjiling",
    label: "West Bengal",
  },
  {
    id: "273",
    value: "Chikkamagaluru",
    label: "Karnataka",
  },
  {
    id: "274",
    value: "Gudivada",
    label: "Andhra Pradesh",
  },
  {
    id: "275",
    value: "Baleshwar Town",
    label: "Odisha",
  },
  {
    id: "276",
    value: "Mancherial",
    label: "Telangana",
  },
  {
    id: "277",
    value: "Srikakulam",
    label: "Andhra Pradesh",
  },
  {
    id: "278",
    value: "Adilabad",
    label: "Telangana",
  },
  {
    id: "279",
    value: "Yavatmal",
    label: "Maharashtra",
  },
  {
    id: "280",
    value: "Barnala",
    label: "Punjab",
  },
  {
    id: "281",
    value: "Nagaon",
    label: "Assam",
  },
  {
    id: "282",
    value: "Narasaraopet",
    label: "Andhra Pradesh",
  },
  {
    id: "283",
    value: "Raigarh",
    label: "Chhattisgarh",
  },
  {
    id: "284",
    value: "Roorkee",
    label: "Uttarakhand",
  },
  {
    id: "285",
    value: "Valsad",
    label: "Gujarat",
  },
  {
    id: "286",
    value: "Ambikapur",
    label: "Chhattisgarh",
  },
  {
    id: "287",
    value: "Giridih",
    label: "Jharkhand",
  },
  {
    id: "288",
    value: "Chandausi",
    label: "Uttar Pradesh",
  },
  {
    id: "289",
    value: "Purulia",
    label: "West Bengal",
  },
  {
    id: "290",
    value: "Patan",
    label: "Gujarat",
  },
  {
    id: "291",
    value: "Bagaha",
    label: "Bihar",
  },
  {
    id: "292",
    value: "Hardoi ",
    label: "Uttar Pradesh",
  },
  {
    id: "293",
    value: "Achalpur",
    label: "Maharashtra",
  },
  {
    id: "294",
    value: "Osmanabad",
    label: "Maharashtra",
  },
  {
    id: "295",
    value: "Deesa",
    label: "Gujarat",
  },
  {
    id: "296",
    value: "Nandurbar",
    label: "Maharashtra",
  },
  {
    id: "297",
    value: "Azamgarh",
    label: "Uttar Pradesh",
  },
  {
    id: "298",
    value: "Ramgarh",
    label: "Jharkhand",
  },
  {
    id: "299",
    value: "Firozpur",
    label: "Punjab",
  },
  {
    id: "300",
    value: "Baripada Town",
    label: "Odisha",
  },
  {
    id: "301",
    value: "Karwar",
    label: "Karnataka",
  },
  {
    id: "302",
    value: "Siwan",
    label: "Bihar",
  },
  {
    id: "303",
    value: "Rajampet",
    label: "Andhra Pradesh",
  },
  {
    id: "304",
    value: "Pudukkottai",
    label: "Tamil Nadu",
  },
  {
    id: "305",
    value: "Anantnag",
    label: "Jammu and Kashmir",
  },
  {
    id: "306",
    value: "Tadpatri",
    label: "Andhra Pradesh",
  },
  {
    id: "307",
    value: "Satara",
    label: "Maharashtra",
  },
  {
    id: "308",
    value: "Bhadrak",
    label: "Odisha",
  },
  {
    id: "309",
    value: "Kishanganj",
    label: "Bihar",
  },
  {
    id: "310",
    value: "Suryapet",
    label: "Telangana",
  },
  {
    id: "311",
    value: "Wardha",
    label: "Maharashtra",
  },
  {
    id: "312",
    value: "Ranebennuru",
    label: "Karnataka",
  },
  {
    id: "313",
    value: "Amreli",
    label: "Gujarat",
  },
  {
    id: "314",
    value: "Neyveli (TS)",
    label: "Tamil Nadu",
  },
  {
    id: "315",
    value: "Jamalpur",
    label: "Bihar",
  },
  {
    id: "316",
    value: "Marmagao",
    label: "Goa",
  },
  {
    id: "317",
    value: "Udgir",
    label: "Maharashtra",
  },
  {
    id: "318",
    value: "Tadepalligudem",
    label: "Andhra Pradesh",
  },
  {
    id: "319",
    value: "Nagapattinam",
    label: "Tamil Nadu",
  },
  {
    id: "320",
    value: "Buxar",
    label: "Bihar",
  },
  {
    id: "321",
    value: "Aurangabad",
    label: "Maharashtra",
  },
  {
    id: "322",
    value: "Jehanabad",
    label: "Bihar",
  },
  {
    id: "323",
    value: "Phagwara",
    label: "Punjab",
  },
  {
    id: "324",
    value: "Khair",
    label: "Uttar Pradesh",
  },
  {
    id: "325",
    value: "Sawai Madhopur",
    label: "Rajasthan",
  },
  {
    id: "326",
    value: "Kapurthala",
    label: "Punjab",
  },
  {
    id: "327",
    value: "Chilakaluripet",
    label: "Andhra Pradesh",
  },
  {
    id: "328",
    value: "Aurangabad",
    label: "Bihar",
  },
  {
    id: "329",
    value: "Malappuram",
    label: "Kerala",
  },
  {
    id: "330",
    value: "Rewari",
    label: "Haryana",
  },
  {
    id: "331",
    value: "Nagaur",
    label: "Rajasthan",
  },
  {
    id: "332",
    value: "Sultanpur",
    label: "Uttar Pradesh",
  },
  {
    id: "333",
    value: "Nagda",
    label: "Madhya Pradesh",
  },
  {
    id: "334",
    value: "Port Blair",
    label: "Andaman and Nicobar Islands",
  },
  {
    id: "335",
    value: "Lakhisarai",
    label: "Bihar",
  },
  {
    id: "336",
    value: "Panaji",
    label: "Goa",
  },
  {
    id: "337",
    value: "Tinsukia",
    label: "Assam",
  },
  {
    id: "338",
    value: "Itarsi",
    label: "Madhya Pradesh",
  },
  {
    id: "339",
    value: "Kohima",
    label: "Nagaland",
  },
  {
    id: "340",
    value: "Balangir",
    label: "Odisha",
  },
  {
    id: "341",
    value: "Nawada",
    label: "Bihar",
  },
  {
    id: "342",
    value: "Jharsuguda",
    label: "Odisha",
  },
  {
    id: "343",
    value: "Jagtial",
    label: "Telangana",
  },
  {
    id: "344",
    value: "Viluppuram",
    label: "Tamil Nadu",
  },
  {
    id: "345",
    value: "Amalner",
    label: "Maharashtra",
  },
  {
    id: "346",
    value: "Zirakpur",
    label: "Punjab",
  },
  {
    id: "347",
    value: "Tanda",
    label: "Uttar Pradesh",
  },
  {
    id: "348",
    value: "Tiruchengode",
    label: "Tamil Nadu",
  },
  {
    id: "349",
    value: "Nagina",
    label: "Uttar Pradesh",
  },
  {
    id: "350",
    value: "Yemmiganur",
    label: "Andhra Pradesh",
  },
  {
    id: "351",
    value: "Vaniyambadi",
    label: "Tamil Nadu",
  },
  {
    id: "352",
    value: "Sarni",
    label: "Madhya Pradesh",
  },
  {
    id: "353",
    value: "Theni Allinagaram",
    label: "Tamil Nadu",
  },
  {
    id: "354",
    value: "Margao",
    label: "Goa",
  },
  {
    id: "355",
    value: "Akot",
    label: "Maharashtra",
  },
  {
    id: "356",
    value: "Sehore",
    label: "Madhya Pradesh",
  },
  {
    id: "357",
    value: "Mhow Cantonment",
    label: "Madhya Pradesh",
  },
  {
    id: "358",
    value: "Kot Kapura",
    label: "Punjab",
  },
  {
    id: "359",
    value: "Makrana",
    label: "Rajasthan",
  },
  {
    id: "360",
    value: "Pandharpur",
    label: "Maharashtra",
  },
  {
    id: "361",
    value: "Miryalaguda",
    label: "Telangana",
  },
  {
    id: "362",
    value: "Shamli",
    label: "Uttar Pradesh",
  },
  {
    id: "363",
    value: "Seoni",
    label: "Madhya Pradesh",
  },
  {
    id: "364",
    value: "Ranibennur",
    label: "Karnataka",
  },
  {
    id: "365",
    value: "Kadiri",
    label: "Andhra Pradesh",
  },
  {
    id: "366",
    value: "Shrirampur",
    label: "Maharashtra",
  },
  {
    id: "367",
    value: "Rudrapur",
    label: "Uttarakhand",
  },
  {
    id: "368",
    value: "Parli",
    label: "Maharashtra",
  },
  {
    id: "369",
    value: "Najibabad",
    label: "Uttar Pradesh",
  },
  {
    id: "370",
    value: "Nirmal",
    label: "Telangana",
  },
  {
    id: "371",
    value: "Udhagamandalam",
    label: "Tamil Nadu",
  },
  {
    id: "372",
    value: "Shikohabad",
    label: "Uttar Pradesh",
  },
  {
    id: "373",
    value: "Jhumri Tilaiya",
    label: "Jharkhand",
  },
  {
    id: "374",
    value: "Aruppukkottai",
    label: "Tamil Nadu",
  },
  {
    id: "375",
    value: "Ponnani",
    label: "Kerala",
  },
  {
    id: "376",
    value: "Jamui",
    label: "Bihar",
  },
  {
    id: "377",
    value: "Sitamarhi",
    label: "Bihar",
  },
  {
    id: "378",
    value: "Chirala",
    label: "Andhra Pradesh",
  },
  {
    id: "379",
    value: "Anjar",
    label: "Gujarat",
  },
  {
    id: "380",
    value: "Karaikal",
    label: "Puducherry",
  },
  {
    id: "381",
    value: "Hansi",
    label: "Haryana",
  },
  {
    id: "382",
    value: "Anakapalle",
    label: "Andhra Pradesh",
  },
  {
    id: "383",
    value: "Mahasamund",
    label: "Chhattisgarh",
  },
  {
    id: "384",
    value: "Faridkot",
    label: "Punjab",
  },
  {
    id: "385",
    value: "Saunda",
    label: "Jharkhand",
  },
  {
    id: "386",
    value: "Dhoraji",
    label: "Gujarat",
  },
  {
    id: "387",
    value: "Paramakudi",
    label: "Tamil Nadu",
  },
  {
    id: "388",
    value: "Balaghat",
    label: "Madhya Pradesh",
  },
  {
    id: "389",
    value: "Sujangarh",
    label: "Rajasthan",
  },
  {
    id: "390",
    value: "Khambhat",
    label: "Gujarat",
  },
  {
    id: "391",
    value: "Muktsar",
    label: "Punjab",
  },
  {
    id: "392",
    value: "Rajpura",
    label: "Punjab",
  },
  {
    id: "393",
    value: "Kavali",
    label: "Andhra Pradesh",
  },
  {
    id: "394",
    value: "Dhamtari",
    label: "Chhattisgarh",
  },
  {
    id: "395",
    value: "Ashok Nagar",
    label: "Madhya Pradesh",
  },
  {
    id: "396",
    value: "Sardarshahar",
    label: "Rajasthan",
  },
  {
    id: "397",
    value: "Mahuva",
    label: "Gujarat",
  },
  {
    id: "398",
    value: "Bargarh",
    label: "Odisha",
  },
  {
    id: "399",
    value: "Kamareddy",
    label: "Telangana",
  },
  {
    id: "400",
    value: "Sahibganj",
    label: "Jharkhand",
  },
  {
    id: "401",
    value: "Kothagudem",
    label: "Telangana",
  },
  {
    id: "402",
    value: "Ramanagaram",
    label: "Karnataka",
  },
  {
    id: "403",
    value: "Gokak",
    label: "Karnataka",
  },
  {
    id: "404",
    value: "Tikamgarh",
    label: "Madhya Pradesh",
  },
  {
    id: "405",
    value: "Araria",
    label: "Bihar",
  },
  {
    id: "406",
    value: "Rishikesh",
    label: "Uttarakhand",
  },
  {
    id: "407",
    value: "Shahdol",
    label: "Madhya Pradesh",
  },
  {
    id: "408",
    value: "Medininagar (Daltonganj)",
    label: "Jharkhand",
  },
  {
    id: "409",
    value: "Arakkonam",
    label: "Tamil Nadu",
  },
  {
    id: "410",
    value: "Washim",
    label: "Maharashtra",
  },
  {
    id: "411",
    value: "Sangrur",
    label: "Punjab",
  },
  {
    id: "412",
    value: "Bodhan",
    label: "Telangana",
  },
  {
    id: "413",
    value: "Fazilka",
    label: "Punjab",
  },
  {
    id: "414",
    value: "Palacole",
    label: "Andhra Pradesh",
  },
  {
    id: "415",
    value: "Keshod",
    label: "Gujarat",
  },
  {
    id: "416",
    value: "Sullurpeta",
    label: "Andhra Pradesh",
  },
  {
    id: "417",
    value: "Wadhwan",
    label: "Gujarat",
  },
  {
    id: "418",
    value: "Gurdaspur",
    label: "Punjab",
  },
  {
    id: "419",
    value: "Vatakara",
    label: "Kerala",
  },
  {
    id: "420",
    value: "Tura",
    label: "Meghalaya",
  },
  {
    id: "421",
    value: "Narnaul",
    label: "Haryana",
  },
  {
    id: "422",
    value: "Kharar",
    label: "Punjab",
  },
  {
    id: "423",
    value: "Yadgir",
    label: "Karnataka",
  },
  {
    id: "424",
    value: "Ambejogai",
    label: "Maharashtra",
  },
  {
    id: "425",
    value: "Ankleshwar",
    label: "Gujarat",
  },
  {
    id: "426",
    value: "Savarkundla",
    label: "Gujarat",
  },
  {
    id: "427",
    value: "Paradip",
    label: "Odisha",
  },
  {
    id: "428",
    value: "Virudhachalam",
    label: "Tamil Nadu",
  },
  {
    id: "429",
    value: "Kanhangad",
    label: "Kerala",
  },
  {
    id: "430",
    value: "Kadi",
    label: "Gujarat",
  },
  {
    id: "431",
    value: "Srivilliputhur",
    label: "Tamil Nadu",
  },
  {
    id: "432",
    value: "Gobindgarh",
    label: "Punjab",
  },
  {
    id: "433",
    value: "Tindivanam",
    label: "Tamil Nadu",
  },
  {
    id: "434",
    value: "Mansa",
    label: "Punjab",
  },
  {
    id: "435",
    value: "Taliparamba",
    label: "Kerala",
  },
  {
    id: "436",
    value: "Manmad",
    label: "Maharashtra",
  },
  {
    id: "437",
    value: "Tanuku",
    label: "Andhra Pradesh",
  },
  {
    id: "438",
    value: "Rayachoti",
    label: "Andhra Pradesh",
  },
  {
    id: "439",
    value: "Virudhunagar",
    label: "Tamil Nadu",
  },
  {
    id: "440",
    value: "Koyilandy",
    label: "Kerala",
  },
  {
    id: "441",
    value: "Jorhat",
    label: "Assam",
  },
  {
    id: "442",
    value: "Karur",
    label: "Tamil Nadu",
  },
  {
    id: "443",
    value: "Valparai",
    label: "Tamil Nadu",
  },
  {
    id: "444",
    value: "Srikalahasti",
    label: "Andhra Pradesh",
  },
  {
    id: "445",
    value: "Neyyattinkara",
    label: "Kerala",
  },
  {
    id: "446",
    value: "Bapatla",
    label: "Andhra Pradesh",
  },
  {
    id: "447",
    value: "Fatehabad",
    label: "Haryana",
  },
  {
    id: "448",
    value: "Malout",
    label: "Punjab",
  },
  {
    id: "449",
    value: "Sankarankovil",
    label: "Tamil Nadu",
  },
  {
    id: "450",
    value: "Tenkasi",
    label: "Tamil Nadu",
  },
  {
    id: "451",
    value: "Ratnagiri",
    label: "Maharashtra",
  },
  {
    id: "452",
    value: "Rabkavi Banhatti",
    label: "Karnataka",
  },
  {
    id: "453",
    value: "Sikandrabad",
    label: "Uttar Pradesh",
  },
  {
    id: "454",
    value: "Chaibasa",
    label: "Jharkhand",
  },
  {
    id: "455",
    value: "Chirmiri",
    label: "Chhattisgarh",
  },
  {
    id: "456",
    value: "Palwancha",
    label: "Telangana",
  },
  {
    id: "457",
    value: "Bhawanipatna",
    label: "Odisha",
  },
  {
    id: "458",
    value: "Kayamkulam",
    label: "Kerala",
  },
  {
    id: "459",
    value: "Pithampur",
    label: "Madhya Pradesh",
  },
  {
    id: "460",
    value: "Nabha",
    label: "Punjab",
  },
  {
    id: "461",
    value: "Shahabad, Hardoi",
    label: "Uttar Pradesh",
  },
  {
    id: "462",
    value: "Dhenkanal",
    label: "Odisha",
  },
  {
    id: "463",
    value: "Uran Islampur",
    label: "Maharashtra",
  },
  {
    id: "464",
    value: "Gopalganj",
    label: "Bihar",
  },
  {
    id: "465",
    value: "Bongaigaon City",
    label: "Assam",
  },
  {
    id: "466",
    value: "Palani",
    label: "Tamil Nadu",
  },
  {
    id: "467",
    value: "Pusad",
    label: "Maharashtra",
  },
  {
    id: "468",
    value: "Sopore",
    label: "Jammu and Kashmir",
  },
  {
    id: "469",
    value: "Pilkhuwa",
    label: "Uttar Pradesh",
  },
  {
    id: "470",
    value: "Tarn Taran",
    label: "Punjab",
  },
  {
    id: "471",
    value: "Renukoot",
    label: "Uttar Pradesh",
  },
  {
    id: "472",
    value: "Mandamarri",
    label: "Telangana",
  },
  {
    id: "473",
    value: "Shahabad",
    label: "Karnataka",
  },
  {
    id: "474",
    value: "Barbil",
    label: "Odisha",
  },
  {
    id: "475",
    value: "Koratla",
    label: "Telangana",
  },
  {
    id: "476",
    value: "Madhubani",
    label: "Bihar",
  },
  {
    id: "477",
    value: "Arambagh",
    label: "West Bengal",
  },
  {
    id: "478",
    value: "Gohana",
    label: "Haryana",
  },
  {
    id: "479",
    value: "Ladnu",
    label: "Rajasthan",
  },
  {
    id: "480",
    value: "Pattukkottai",
    label: "Tamil Nadu",
  },
  {
    id: "481",
    value: "Sirsi",
    label: "Karnataka",
  },
  {
    id: "482",
    value: "Sircilla",
    label: "Telangana",
  },
  {
    id: "483",
    value: "Tamluk",
    label: "West Bengal",
  },
  {
    id: "484",
    value: "Jagraon",
    label: "Punjab",
  },
  {
    id: "485",
    value: "AlipurdUrban Agglomerationr",
    label: "West Bengal",
  },
  {
    id: "486",
    value: "Alirajpur",
    label: "Madhya Pradesh",
  },
  {
    id: "487",
    value: "Tandur",
    label: "Telangana",
  },
  {
    id: "488",
    value: "Naidupet",
    label: "Andhra Pradesh",
  },
  {
    id: "489",
    value: "Tirupathur",
    label: "Tamil Nadu",
  },
  {
    id: "490",
    value: "Tohana",
    label: "Haryana",
  },
  {
    id: "491",
    value: "Ratangarh",
    label: "Rajasthan",
  },
  {
    id: "492",
    value: "Dhubri",
    label: "Assam",
  },
  {
    id: "493",
    value: "Masaurhi",
    label: "Bihar",
  },
  {
    id: "494",
    value: "Visnagar",
    label: "Gujarat",
  },
  {
    id: "495",
    value: "Vrindavan",
    label: "Uttar Pradesh",
  },
  {
    id: "496",
    value: "Nokha",
    label: "Rajasthan",
  },
  {
    id: "497",
    value: "Nagari",
    label: "Andhra Pradesh",
  },
  {
    id: "498",
    value: "Narwana",
    label: "Haryana",
  },
  {
    id: "499",
    value: "Ramanathapuram",
    label: "Tamil Nadu",
  },
  {
    id: "500",
    value: "Ujhani",
    label: "Uttar Pradesh",
  },
  {
    id: "501",
    value: "Samastipur",
    label: "Bihar",
  },
  {
    id: "502",
    value: "Laharpur",
    label: "Uttar Pradesh",
  },
  {
    id: "503",
    value: "Sangamner",
    label: "Maharashtra",
  },
  {
    id: "504",
    value: "Nimbahera",
    label: "Rajasthan",
  },
  {
    id: "505",
    value: "Siddipet",
    label: "Telangana",
  },
  {
    id: "506",
    value: "Suri",
    label: "West Bengal",
  },
  {
    id: "507",
    value: "Diphu",
    label: "Assam",
  },
  {
    id: "508",
    value: "Jhargram",
    label: "West Bengal",
  },
  {
    id: "509",
    value: "Shirpur-Warwade",
    label: "Maharashtra",
  },
  {
    id: "510",
    value: "Tilhar",
    label: "Uttar Pradesh",
  },
  {
    id: "511",
    value: "Sindhnur",
    label: "Karnataka",
  },
  {
    id: "512",
    value: "Udumalaipettai",
    label: "Tamil Nadu",
  },
  {
    id: "513",
    value: "Malkapur",
    label: "Maharashtra",
  },
  {
    id: "514",
    value: "Wanaparthy",
    label: "Telangana",
  },
  {
    id: "515",
    value: "Gudur",
    label: "Andhra Pradesh",
  },
  {
    id: "516",
    value: "Kendujhar",
    label: "Odisha",
  },
  {
    id: "517",
    value: "Mandla",
    label: "Madhya Pradesh",
  },
  {
    id: "518",
    value: "Mandi",
    label: "Himachal Pradesh",
  },
  {
    id: "519",
    value: "Nedumangad",
    label: "Kerala",
  },
  {
    id: "520",
    value: "North Lakhimpur",
    label: "Assam",
  },
  {
    id: "521",
    value: "Vinukonda",
    label: "Andhra Pradesh",
  },
  {
    id: "522",
    value: "Tiptur",
    label: "Karnataka",
  },
  {
    id: "523",
    value: "Gobichettipalayam",
    label: "Tamil Nadu",
  },
  {
    id: "524",
    value: "Sunabeda",
    label: "Odisha",
  },
  {
    id: "525",
    value: "Wani",
    label: "Maharashtra",
  },
  {
    id: "526",
    value: "Upleta",
    label: "Gujarat",
  },
  {
    id: "527",
    value: "Narasapuram",
    label: "Andhra Pradesh",
  },
  {
    id: "528",
    value: "Nuzvid",
    label: "Andhra Pradesh",
  },
  {
    id: "529",
    value: "Tezpur",
    label: "Assam",
  },
  {
    id: "530",
    value: "Una",
    label: "Gujarat",
  },
  {
    id: "531",
    value: "Markapur",
    label: "Andhra Pradesh",
  },
  {
    id: "532",
    value: "Sheopur",
    label: "Madhya Pradesh",
  },
  {
    id: "533",
    value: "Thiruvarur",
    label: "Tamil Nadu",
  },
  {
    id: "534",
    value: "Sidhpur",
    label: "Gujarat",
  },
  {
    id: "535",
    value: "Sahaswan",
    label: "Uttar Pradesh",
  },
  {
    id: "536",
    value: "Suratgarh",
    label: "Rajasthan",
  },
  {
    id: "537",
    value: "Shajapur",
    label: "Madhya Pradesh",
  },
  {
    id: "538",
    value: "Rayagada",
    label: "Odisha",
  },
  {
    id: "539",
    value: "Lonavla",
    label: "Maharashtra",
  },
  {
    id: "540",
    value: "Ponnur",
    label: "Andhra Pradesh",
  },
  {
    id: "541",
    value: "Kagaznagar",
    label: "Telangana",
  },
  {
    id: "542",
    value: "Gadwal",
    label: "Telangana",
  },
  {
    id: "543",
    value: "Bhatapara",
    label: "Chhattisgarh",
  },
  {
    id: "544",
    value: "Kandukur",
    label: "Andhra Pradesh",
  },
  {
    id: "545",
    value: "Sangareddy",
    label: "Telangana",
  },
  {
    id: "546",
    value: "Unjha",
    label: "Gujarat",
  },
  {
    id: "547",
    value: "Lunglei",
    label: "Mizoram",
  },
  {
    id: "548",
    value: "Karimganj",
    label: "Assam",
  },
  {
    id: "549",
    value: "Kannur",
    label: "Kerala",
  },
  {
    id: "550",
    value: "Bobbili",
    label: "Andhra Pradesh",
  },
  {
    id: "551",
    value: "Mokameh",
    label: "Bihar",
  },
  {
    id: "552",
    value: "Talegaon Dabhade",
    label: "Maharashtra",
  },
  {
    id: "553",
    value: "Anjangaon",
    label: "Maharashtra",
  },
  {
    id: "554",
    value: "Mangrol",
    label: "Gujarat",
  },
  {
    id: "555",
    value: "Sunam",
    label: "Punjab",
  },
  {
    id: "556",
    value: "Gangarampur",
    label: "West Bengal",
  },
  {
    id: "557",
    value: "Thiruvallur",
    label: "Tamil Nadu",
  },
  {
    id: "558",
    value: "Tirur",
    label: "Kerala",
  },
  {
    id: "559",
    value: "Rath",
    label: "Uttar Pradesh",
  },
  {
    id: "560",
    value: "Jatani",
    label: "Odisha",
  },
  {
    id: "561",
    value: "Viramgam",
    label: "Gujarat",
  },
  {
    id: "562",
    value: "Rajsamand",
    label: "Rajasthan",
  },
  {
    id: "563",
    value: "Yanam",
    label: "Puducherry",
  },
  {
    id: "564",
    value: "Kottayam",
    label: "Kerala",
  },
  {
    id: "565",
    value: "Panruti",
    label: "Tamil Nadu",
  },
  {
    id: "566",
    value: "Dhuri",
    label: "Punjab",
  },
  {
    id: "567",
    value: "Namakkal",
    label: "Tamil Nadu",
  },
  {
    id: "568",
    value: "Kasaragod",
    label: "Kerala",
  },
  {
    id: "569",
    value: "Modasa",
    label: "Gujarat",
  },
  {
    id: "570",
    value: "Rayadurg",
    label: "Andhra Pradesh",
  },
  {
    id: "571",
    value: "Supaul",
    label: "Bihar",
  },
  {
    id: "572",
    value: "Kunnamkulam",
    label: "Kerala",
  },
  {
    id: "573",
    value: "Umred",
    label: "Maharashtra",
  },
  {
    id: "574",
    value: "Bellampalle",
    label: "Telangana",
  },
  {
    id: "575",
    value: "Sibsagar",
    label: "Assam",
  },
  {
    id: "576",
    value: "Mandi Dabwali",
    label: "Haryana",
  },
  {
    id: "577",
    value: "Ottappalam",
    label: "Kerala",
  },
  {
    id: "578",
    value: "Dumraon",
    label: "Bihar",
  },
  {
    id: "579",
    value: "Samalkot",
    label: "Andhra Pradesh",
  },
  {
    id: "580",
    value: "Jaggaiahpet",
    label: "Andhra Pradesh",
  },
  {
    id: "581",
    value: "Goalpara",
    label: "Assam",
  },
  {
    id: "582",
    value: "Tuni",
    label: "Andhra Pradesh",
  },
  {
    id: "583",
    value: "Lachhmangarh",
    label: "Rajasthan",
  },
  {
    id: "584",
    value: "Bhongir",
    label: "Telangana",
  },
  {
    id: "585",
    value: "Amalapuram",
    label: "Andhra Pradesh",
  },
  {
    id: "586",
    value: "Firozpur Cantt.",
    label: "Punjab",
  },
  {
    id: "587",
    value: "Vikarabad",
    label: "Telangana",
  },
  {
    id: "588",
    value: "Thiruvalla",
    label: "Kerala",
  },
  {
    id: "589",
    value: "Sherkot",
    label: "Uttar Pradesh",
  },
  {
    id: "590",
    value: "Palghar",
    label: "Maharashtra",
  },
  {
    id: "591",
    value: "Shegaon",
    label: "Maharashtra",
  },
  {
    id: "592",
    value: "Jangaon",
    label: "Telangana",
  },
  {
    id: "593",
    value: "Bheemunipatnam",
    label: "Andhra Pradesh",
  },
  {
    id: "594",
    value: "Panna",
    label: "Madhya Pradesh",
  },
  {
    id: "595",
    value: "Thodupuzha",
    label: "Kerala",
  },
  {
    id: "596",
    value: "KathUrban Agglomeration",
    label: "Jammu and Kashmir",
  },
  {
    id: "597",
    value: "Palitana",
    label: "Gujarat",
  },
  {
    id: "598",
    value: "Arwal",
    label: "Bihar",
  },
  {
    id: "599",
    value: "Venkatagiri",
    label: "Andhra Pradesh",
  },
  {
    id: "600",
    value: "Kalpi",
    label: "Uttar Pradesh",
  },
  {
    id: "601",
    value: "Rajgarh (Churu)",
    label: "Rajasthan",
  },
  {
    id: "602",
    value: "Sattenapalle",
    label: "Andhra Pradesh",
  },
  {
    id: "603",
    value: "Arsikere",
    label: "Karnataka",
  },
  {
    id: "604",
    value: "Ozar",
    label: "Maharashtra",
  },
  {
    id: "605",
    value: "Thirumangalam",
    label: "Tamil Nadu",
  },
  {
    id: "606",
    value: "Petlad",
    label: "Gujarat",
  },
  {
    id: "607",
    value: "Nasirabad",
    label: "Rajasthan",
  },
  {
    id: "608",
    value: "Phaltan",
    label: "Maharashtra",
  },
  {
    id: "609",
    value: "Rampurhat",
    label: "West Bengal",
  },
  {
    id: "610",
    value: "Nanjangud",
    label: "Karnataka",
  },
  {
    id: "611",
    value: "Forbesganj",
    label: "Bihar",
  },
  {
    id: "612",
    value: "Tundla",
    label: "Uttar Pradesh",
  },
  {
    id: "613",
    value: "BhabUrban Agglomeration",
    label: "Bihar",
  },
  {
    id: "614",
    value: "Sagara",
    label: "Karnataka",
  },
  {
    id: "615",
    value: "Pithapuram",
    label: "Andhra Pradesh",
  },
  {
    id: "616",
    value: "Sira",
    label: "Karnataka",
  },
  {
    id: "617",
    value: "Bhadrachalam",
    label: "Telangana",
  },
  {
    id: "618",
    value: "Charkhi Dadri",
    label: "Haryana",
  },
  {
    id: "619",
    value: "Chatra",
    label: "Jharkhand",
  },
  {
    id: "620",
    value: "Palasa Kasibugga",
    label: "Andhra Pradesh",
  },
  {
    id: "621",
    value: "Nohar",
    label: "Rajasthan",
  },
  {
    id: "622",
    value: "Yevla",
    label: "Maharashtra",
  },
  {
    id: "623",
    value: "Sirhind Fatehgarh Sahib",
    label: "Punjab",
  },
  {
    id: "624",
    value: "Bhainsa",
    label: "Telangana",
  },
  {
    id: "625",
    value: "Parvathipuram",
    label: "Andhra Pradesh",
  },
  {
    id: "626",
    value: "Shahade",
    label: "Maharashtra",
  },
  {
    id: "627",
    value: "Chalakudy",
    label: "Kerala",
  },
  {
    id: "628",
    value: "Narkatiaganj",
    label: "Bihar",
  },
  {
    id: "629",
    value: "Kapadvanj",
    label: "Gujarat",
  },
  {
    id: "630",
    value: "Macherla",
    label: "Andhra Pradesh",
  },
  {
    id: "631",
    value: "Raghogarh-Vijaypur",
    label: "Madhya Pradesh",
  },
  {
    id: "632",
    value: "Rupnagar",
    label: "Punjab",
  },
  {
    id: "633",
    value: "Naugachhia",
    label: "Bihar",
  },
  {
    id: "634",
    value: "Sendhwa",
    label: "Madhya Pradesh",
  },
  {
    id: "635",
    value: "Byasanagar",
    label: "Odisha",
  },
  {
    id: "636",
    value: "Sandila",
    label: "Uttar Pradesh",
  },
  {
    id: "637",
    value: "Gooty",
    label: "Andhra Pradesh",
  },
  {
    id: "638",
    value: "Salur",
    label: "Andhra Pradesh",
  },
  {
    id: "639",
    value: "Nanpara",
    label: "Uttar Pradesh",
  },
  {
    id: "640",
    value: "Sardhana",
    label: "Uttar Pradesh",
  },
  {
    id: "641",
    value: "Vita",
    label: "Maharashtra",
  },
  {
    id: "642",
    value: "Gumia",
    label: "Jharkhand",
  },
  {
    id: "643",
    value: "Puttur",
    label: "Karnataka",
  },
  {
    id: "644",
    value: "Jalandhar Cantt.",
    label: "Punjab",
  },
  {
    id: "645",
    value: "Nehtaur",
    label: "Uttar Pradesh",
  },
  {
    id: "646",
    value: "Changanassery",
    label: "Kerala",
  },
  {
    id: "647",
    value: "Mandapeta",
    label: "Andhra Pradesh",
  },
  {
    id: "648",
    value: "Dumka",
    label: "Jharkhand",
  },
  {
    id: "649",
    value: "Seohara",
    label: "Uttar Pradesh",
  },
  {
    id: "650",
    value: "Umarkhed",
    label: "Maharashtra",
  },
  {
    id: "651",
    value: "Madhupur",
    label: "Jharkhand",
  },
  {
    id: "652",
    value: "Vikramasingapuram",
    label: "Tamil Nadu",
  },
  {
    id: "653",
    value: "Punalur",
    label: "Kerala",
  },
  {
    id: "654",
    value: "Kendrapara",
    label: "Odisha",
  },
  {
    id: "655",
    value: "Sihor",
    label: "Gujarat",
  },
  {
    id: "656",
    value: "Nellikuppam",
    label: "Tamil Nadu",
  },
  {
    id: "657",
    value: "Samana",
    label: "Punjab",
  },
  {
    id: "658",
    value: "Warora",
    label: "Maharashtra",
  },
  {
    id: "659",
    value: "Nilambur",
    label: "Kerala",
  },
  {
    id: "660",
    value: "Rasipuram",
    label: "Tamil Nadu",
  },
  {
    id: "661",
    value: "Ramnagar",
    label: "Uttarakhand",
  },
  {
    id: "662",
    value: "Jammalamadugu",
    label: "Andhra Pradesh",
  },
  {
    id: "663",
    value: "Nawanshahr",
    label: "Punjab",
  },
  {
    id: "664",
    value: "Thoubal",
    label: "Manipur",
  },
  {
    id: "665",
    value: "Athni",
    label: "Karnataka",
  },
  {
    id: "666",
    value: "Cherthala",
    label: "Kerala",
  },
  {
    id: "667",
    value: "Sidhi",
    label: "Madhya Pradesh",
  },
  {
    id: "668",
    value: "Farooqnagar",
    label: "Telangana",
  },
  {
    id: "669",
    value: "Peddapuram",
    label: "Andhra Pradesh",
  },
  {
    id: "670",
    value: "Chirkunda",
    label: "Jharkhand",
  },
  {
    id: "671",
    value: "Pachora",
    label: "Maharashtra",
  },
  {
    id: "672",
    value: "Madhepura",
    label: "Bihar",
  },
  {
    id: "673",
    value: "Pithoragarh",
    label: "Uttarakhand",
  },
  {
    id: "674",
    value: "Tumsar",
    label: "Maharashtra",
  },
  {
    id: "675",
    value: "Phalodi",
    label: "Rajasthan",
  },
  {
    id: "676",
    value: "Tiruttani",
    label: "Tamil Nadu",
  },
  {
    id: "677",
    value: "Rampura Phul",
    label: "Punjab",
  },
  {
    id: "678",
    value: "Perinthalmanna",
    label: "Kerala",
  },
  {
    id: "679",
    value: "Padrauna",
    label: "Uttar Pradesh",
  },
  {
    id: "680",
    value: "Pipariya",
    label: "Madhya Pradesh",
  },
  {
    id: "681",
    value: "Dalli-Rajhara",
    label: "Chhattisgarh",
  },
  {
    id: "682",
    value: "Punganur",
    label: "Andhra Pradesh",
  },
  {
    id: "683",
    value: "Mattannur",
    label: "Kerala",
  },
  {
    id: "684",
    value: "Mathura",
    label: "Uttar Pradesh",
  },
  {
    id: "685",
    value: "Thakurdwara",
    label: "Uttar Pradesh",
  },
  {
    id: "686",
    value: "Nandivaram-Guduvancheri",
    label: "Tamil Nadu",
  },
  {
    id: "687",
    value: "Mulbagal",
    label: "Karnataka",
  },
  {
    id: "688",
    value: "Manjlegaon",
    label: "Maharashtra",
  },
  {
    id: "689",
    value: "Wankaner",
    label: "Gujarat",
  },
  {
    id: "690",
    value: "Sillod",
    label: "Maharashtra",
  },
  {
    id: "691",
    value: "Nidadavole",
    label: "Andhra Pradesh",
  },
  {
    id: "692",
    value: "Surapura",
    label: "Karnataka",
  },
  {
    id: "693",
    value: "Rajagangapur",
    label: "Odisha",
  },
  {
    id: "694",
    value: "Sheikhpura",
    label: "Bihar",
  },
  {
    id: "695",
    value: "Parlakhemundi",
    label: "Odisha",
  },
  {
    id: "696",
    value: "Kalimpong",
    label: "West Bengal",
  },
  {
    id: "697",
    value: "Siruguppa",
    label: "Karnataka",
  },
  {
    id: "698",
    value: "Arvi",
    label: "Maharashtra",
  },
  {
    id: "699",
    value: "Limbdi",
    label: "Gujarat",
  },
  {
    id: "700",
    value: "Barpeta",
    label: "Assam",
  },
  {
    id: "701",
    value: "Manglaur",
    label: "Uttarakhand",
  },
  {
    id: "702",
    value: "Repalle",
    label: "Andhra Pradesh",
  },
  {
    id: "703",
    value: "Mudhol",
    label: "Karnataka",
  },
  {
    id: "704",
    value: "Shujalpur",
    label: "Madhya Pradesh",
  },
  {
    id: "705",
    value: "Mandvi",
    label: "Gujarat",
  },
  {
    id: "706",
    value: "Thangadh",
    label: "Gujarat",
  },
  {
    id: "707",
    value: "Sironj",
    label: "Madhya Pradesh",
  },
  {
    id: "708",
    value: "Nandura",
    label: "Maharashtra",
  },
  {
    id: "709",
    value: "Shoranur",
    label: "Kerala",
  },
  {
    id: "710",
    value: "Nathdwara",
    label: "Rajasthan",
  },
  {
    id: "711",
    value: "Periyakulam",
    label: "Tamil Nadu",
  },
  {
    id: "712",
    value: "Sultanganj",
    label: "Bihar",
  },
  {
    id: "713",
    value: "Medak",
    label: "Telangana",
  },
  {
    id: "714",
    value: "Narayanpet",
    label: "Telangana",
  },
  {
    id: "715",
    value: "Raxaul Bazar",
    label: "Bihar",
  },
  {
    id: "716",
    value: "Rajauri",
    label: "Jammu and Kashmir",
  },
  {
    id: "717",
    value: "Pernampattu",
    label: "Tamil Nadu",
  },
  {
    id: "718",
    value: "Nainital",
    label: "Uttarakhand",
  },
  {
    id: "719",
    value: "Ramachandrapuram",
    label: "Andhra Pradesh",
  },
  {
    id: "720",
    value: "Vaijapur",
    label: "Maharashtra",
  },
  {
    id: "721",
    value: "Nangal",
    label: "Punjab",
  },
  {
    id: "722",
    value: "Sidlaghatta",
    label: "Karnataka",
  },
  {
    id: "723",
    value: "Punch",
    label: "Jammu and Kashmir",
  },
  {
    id: "724",
    value: "Pandhurna",
    label: "Madhya Pradesh",
  },
  {
    id: "725",
    value: "Wadgaon Road",
    label: "Maharashtra",
  },
  {
    id: "726",
    value: "Talcher",
    label: "Odisha",
  },
  {
    id: "727",
    value: "Varkala",
    label: "Kerala",
  },
  {
    id: "728",
    value: "Pilani",
    label: "Rajasthan",
  },
  {
    id: "729",
    value: "Nowgong",
    label: "Madhya Pradesh",
  },
  {
    id: "730",
    value: "Naila Janjgir",
    label: "Chhattisgarh",
  },
  {
    id: "731",
    value: "Mapusa",
    label: "Goa",
  },
  {
    id: "732",
    value: "Vellakoil",
    label: "Tamil Nadu",
  },
  {
    id: "733",
    value: "Merta City",
    label: "Rajasthan",
  },
  {
    id: "734",
    value: "Sivaganga",
    label: "Tamil Nadu",
  },
  {
    id: "735",
    value: "Mandideep",
    label: "Madhya Pradesh",
  },
  {
    id: "736",
    value: "Sailu",
    label: "Maharashtra",
  },
  {
    id: "737",
    value: "Vyara",
    label: "Gujarat",
  },
  {
    id: "738",
    value: "Kovvur",
    label: "Andhra Pradesh",
  },
  {
    id: "739",
    value: "Vadalur",
    label: "Tamil Nadu",
  },
  {
    id: "740",
    value: "Nawabganj",
    label: "Uttar Pradesh",
  },
  {
    id: "741",
    value: "Padra",
    label: "Gujarat",
  },
  {
    id: "742",
    value: "Sainthia",
    label: "West Bengal",
  },
  {
    id: "743",
    value: "Siana",
    label: "Uttar Pradesh",
  },
  {
    id: "744",
    value: "Shahpur",
    label: "Karnataka",
  },
  {
    id: "745",
    value: "Sojat",
    label: "Rajasthan",
  },
  {
    id: "746",
    value: "Noorpur",
    label: "Uttar Pradesh",
  },
  {
    id: "747",
    value: "Paravoor",
    label: "Kerala",
  },
  {
    id: "748",
    value: "Murtijapur",
    label: "Maharashtra",
  },
  {
    id: "749",
    value: "Ramnagar",
    label: "Bihar",
  },
  {
    id: "750",
    value: "Sundargarh",
    label: "Odisha",
  },
  {
    id: "751",
    value: "Taki",
    label: "West Bengal",
  },
  {
    id: "752",
    value: "Saundatti-Yellamma",
    label: "Karnataka",
  },
  {
    id: "753",
    value: "Pathanamthitta",
    label: "Kerala",
  },
  {
    id: "754",
    value: "Wadi",
    label: "Karnataka",
  },
  {
    id: "755",
    value: "Rameshwaram",
    label: "Tamil Nadu",
  },
  {
    id: "756",
    value: "Tasgaon",
    label: "Maharashtra",
  },
  {
    id: "757",
    value: "Sikandra Rao",
    label: "Uttar Pradesh",
  },
  {
    id: "758",
    value: "Sihora",
    label: "Madhya Pradesh",
  },
  {
    id: "759",
    value: "Tiruvethipuram",
    label: "Tamil Nadu",
  },
  {
    id: "760",
    value: "Tiruvuru",
    label: "Andhra Pradesh",
  },
  {
    id: "761",
    value: "Mehkar",
    label: "Maharashtra",
  },
  {
    id: "762",
    value: "Peringathur",
    label: "Kerala",
  },
  {
    id: "763",
    value: "Perambalur",
    label: "Tamil Nadu",
  },
  {
    id: "764",
    value: "Manvi",
    label: "Karnataka",
  },
  {
    id: "765",
    value: "Zunheboto",
    label: "Nagaland",
  },
  {
    id: "766",
    value: "Mahnar Bazar",
    label: "Bihar",
  },
  {
    id: "767",
    value: "Attingal",
    label: "Kerala",
  },
  {
    id: "768",
    value: "Shahbad",
    label: "Haryana",
  },
  {
    id: "769",
    value: "Puranpur",
    label: "Uttar Pradesh",
  },
  {
    id: "770",
    value: "Nelamangala",
    label: "Karnataka",
  },
  {
    id: "771",
    value: "Nakodar",
    label: "Punjab",
  },
  {
    id: "772",
    value: "Lunawada",
    label: "Gujarat",
  },
  {
    id: "773",
    value: "Murshidabad",
    label: "West Bengal",
  },
  {
    id: "774",
    value: "Mahe",
    label: "Puducherry",
  },
  {
    id: "775",
    value: "Lanka",
    label: "Assam",
  },
  {
    id: "776",
    value: "Rudauli",
    label: "Uttar Pradesh",
  },
  {
    id: "777",
    value: "Tuensang",
    label: "Nagaland",
  },
  {
    id: "778",
    value: "Lakshmeshwar",
    label: "Karnataka",
  },
  {
    id: "779",
    value: "Zira",
    label: "Punjab",
  },
  {
    id: "780",
    value: "Yawal",
    label: "Maharashtra",
  },
  {
    id: "781",
    value: "Thana Bhawan",
    label: "Uttar Pradesh",
  },
  {
    id: "782",
    value: "Ramdurg",
    label: "Karnataka",
  },
  {
    id: "783",
    value: "Pulgaon",
    label: "Maharashtra",
  },
  {
    id: "784",
    value: "Sadasivpet",
    label: "Telangana",
  },
  {
    id: "785",
    value: "Nargund",
    label: "Karnataka",
  },
  {
    id: "786",
    value: "Neem-Ka-Thana",
    label: "Rajasthan",
  },
  {
    id: "787",
    value: "Memari",
    label: "West Bengal",
  },
  {
    id: "788",
    value: "Nilanga",
    label: "Maharashtra",
  },
  {
    id: "789",
    value: "Naharlagun",
    label: "Arunachal Pradesh",
  },
  {
    id: "790",
    value: "Pakaur",
    label: "Jharkhand",
  },
  {
    id: "791",
    value: "Wai",
    label: "Maharashtra",
  },
  {
    id: "792",
    value: "Tarikere",
    label: "Karnataka",
  },
  {
    id: "793",
    value: "Malavalli",
    label: "Karnataka",
  },
  {
    id: "794",
    value: "Raisen",
    label: "Madhya Pradesh",
  },
  {
    id: "795",
    value: "Lahar",
    label: "Madhya Pradesh",
  },
  {
    id: "796",
    value: "Uravakonda",
    label: "Andhra Pradesh",
  },
  {
    id: "797",
    value: "Savanur",
    label: "Karnataka",
  },
  {
    id: "798",
    value: "Sirohi",
    label: "Rajasthan",
  },
  {
    id: "799",
    value: "Udhampur",
    label: "Jammu and Kashmir",
  },
  {
    id: "800",
    value: "Umarga",
    label: "Maharashtra",
  },
  {
    id: "801",
    value: "Pratapgarh",
    label: "Rajasthan",
  },
  {
    id: "802",
    value: "Lingsugur",
    label: "Karnataka",
  },
  {
    id: "803",
    value: "Usilampatti",
    label: "Tamil Nadu",
  },
  {
    id: "804",
    value: "Palia Kalan",
    label: "Uttar Pradesh",
  },
  {
    id: "805",
    value: "Wokha",
    label: "Nagaland",
  },
  {
    id: "806",
    value: "Rajpipla",
    label: "Gujarat",
  },
  {
    id: "807",
    value: "Vijayapura",
    label: "Karnataka",
  },
  {
    id: "808",
    value: "Rawatbhata",
    label: "Rajasthan",
  },
  {
    id: "809",
    value: "Sangaria",
    label: "Rajasthan",
  },
  {
    id: "810",
    value: "Paithan",
    label: "Maharashtra",
  },
  {
    id: "811",
    value: "Rahuri",
    label: "Maharashtra",
  },
  {
    id: "812",
    value: "Patti",
    label: "Punjab",
  },
  {
    id: "813",
    value: "Zaidpur",
    label: "Uttar Pradesh",
  },
  {
    id: "814",
    value: "Lalsot",
    label: "Rajasthan",
  },
  {
    id: "815",
    value: "Maihar",
    label: "Madhya Pradesh",
  },
  {
    id: "816",
    value: "Vedaranyam",
    label: "Tamil Nadu",
  },
  {
    id: "817",
    value: "Nawapur",
    label: "Maharashtra",
  },
  {
    id: "818",
    value: "Solan",
    label: "Himachal Pradesh",
  },
  {
    id: "819",
    value: "Vapi",
    label: "Gujarat",
  },
  {
    id: "820",
    value: "Sanawad",
    label: "Madhya Pradesh",
  },
  {
    id: "821",
    value: "Warisaliganj",
    label: "Bihar",
  },
  {
    id: "822",
    value: "Revelganj",
    label: "Bihar",
  },
  {
    id: "823",
    value: "Sabalgarh",
    label: "Madhya Pradesh",
  },
  {
    id: "824",
    value: "Tuljapur",
    label: "Maharashtra",
  },
  {
    id: "825",
    value: "Simdega",
    label: "Jharkhand",
  },
  {
    id: "826",
    value: "Musabani",
    label: "Jharkhand",
  },
  {
    id: "827",
    value: "Kodungallur",
    label: "Kerala",
  },
  {
    id: "828",
    value: "Phulabani",
    label: "Odisha",
  },
  {
    id: "829",
    value: "Umreth",
    label: "Gujarat",
  },
  {
    id: "830",
    value: "Narsipatnam",
    label: "Andhra Pradesh",
  },
  {
    id: "831",
    value: "Nautanwa",
    label: "Uttar Pradesh",
  },
  {
    id: "832",
    value: "Rajgir",
    label: "Bihar",
  },
  {
    id: "833",
    value: "Yellandu",
    label: "Telangana",
  },
  {
    id: "834",
    value: "Sathyamangalam",
    label: "Tamil Nadu",
  },
  {
    id: "835",
    value: "Pilibanga",
    label: "Rajasthan",
  },
  {
    id: "836",
    value: "Morshi",
    label: "Maharashtra",
  },
  {
    id: "837",
    value: "Pehowa",
    label: "Haryana",
  },
  {
    id: "838",
    value: "Sonepur",
    label: "Bihar",
  },
  {
    id: "839",
    value: "Pappinisseri",
    label: "Kerala",
  },
  {
    id: "840",
    value: "Zamania",
    label: "Uttar Pradesh",
  },
  {
    id: "841",
    value: "Mihijam",
    label: "Jharkhand",
  },
  {
    id: "842",
    value: "Purna",
    label: "Maharashtra",
  },
  {
    id: "843",
    value: "Puliyankudi",
    label: "Tamil Nadu",
  },
  {
    id: "844",
    value: "Shikarpur, Bulandshahr",
    label: "Uttar Pradesh",
  },
  {
    id: "845",
    value: "Umaria",
    label: "Madhya Pradesh",
  },
  {
    id: "846",
    value: "Porsa",
    label: "Madhya Pradesh",
  },
  {
    id: "847",
    value: "Naugawan Sadat",
    label: "Uttar Pradesh",
  },
  {
    id: "848",
    value: "Fatehpur Sikri",
    label: "Uttar Pradesh",
  },
  {
    id: "849",
    value: "Manuguru",
    label: "Telangana",
  },
  {
    id: "850",
    value: "Udaipur",
    label: "Tripura",
  },
  {
    id: "851",
    value: "Pipar City",
    label: "Rajasthan",
  },
  {
    id: "852",
    value: "Pattamundai",
    label: "Odisha",
  },
  {
    id: "853",
    value: "Nanjikottai",
    label: "Tamil Nadu",
  },
  {
    id: "854",
    value: "Taranagar",
    label: "Rajasthan",
  },
  {
    id: "855",
    value: "Yerraguntla",
    label: "Andhra Pradesh",
  },
  {
    id: "856",
    value: "Satana",
    label: "Maharashtra",
  },
  {
    id: "857",
    value: "Sherghati",
    label: "Bihar",
  },
  {
    id: "858",
    value: "Sankeshwara",
    label: "Karnataka",
  },
  {
    id: "859",
    value: "Madikeri",
    label: "Karnataka",
  },
  {
    id: "860",
    value: "Thuraiyur",
    label: "Tamil Nadu",
  },
  {
    id: "861",
    value: "Sanand",
    label: "Gujarat",
  },
  {
    id: "862",
    value: "Rajula",
    label: "Gujarat",
  },
  {
    id: "863",
    value: "Kyathampalle",
    label: "Telangana",
  },
  {
    id: "864",
    value: "Shahabad, Rampur",
    label: "Uttar Pradesh",
  },
  {
    id: "865",
    value: "Tilda Newra",
    label: "Chhattisgarh",
  },
  {
    id: "866",
    value: "Narsinghgarh",
    label: "Madhya Pradesh",
  },
  {
    id: "867",
    value: "Chittur-Thathamangalam",
    label: "Kerala",
  },
  {
    id: "868",
    value: "Malaj Khand",
    label: "Madhya Pradesh",
  },
  {
    id: "869",
    value: "Sarangpur",
    label: "Madhya Pradesh",
  },
  {
    id: "870",
    value: "Robertsganj",
    label: "Uttar Pradesh",
  },
  {
    id: "871",
    value: "Sirkali",
    label: "Tamil Nadu",
  },
  {
    id: "872",
    value: "Radhanpur",
    label: "Gujarat",
  },
  {
    id: "873",
    value: "Tiruchendur",
    label: "Tamil Nadu",
  },
  {
    id: "874",
    value: "Utraula",
    label: "Uttar Pradesh",
  },
  {
    id: "875",
    value: "Patratu",
    label: "Jharkhand",
  },
  {
    id: "876",
    value: "Vijainagar, Ajmer",
    label: "Rajasthan",
  },
  {
    id: "877",
    value: "Periyasemur",
    label: "Tamil Nadu",
  },
  {
    id: "878",
    value: "Pathri",
    label: "Maharashtra",
  },
  {
    id: "879",
    value: "Sadabad",
    label: "Uttar Pradesh",
  },
  {
    id: "880",
    value: "Talikota",
    label: "Karnataka",
  },
  {
    id: "881",
    value: "Sinnar",
    label: "Maharashtra",
  },
  {
    id: "882",
    value: "Mungeli",
    label: "Chhattisgarh",
  },
  {
    id: "883",
    value: "Sedam",
    label: "Karnataka",
  },
  {
    id: "884",
    value: "Shikaripur",
    label: "Karnataka",
  },
  {
    id: "885",
    value: "Sumerpur",
    label: "Rajasthan",
  },
  {
    id: "886",
    value: "Sattur",
    label: "Tamil Nadu",
  },
  {
    id: "887",
    value: "Sugauli",
    label: "Bihar",
  },
  {
    id: "888",
    value: "Lumding",
    label: "Assam",
  },
  {
    id: "889",
    value: "Vandavasi",
    label: "Tamil Nadu",
  },
  {
    id: "890",
    value: "Titlagarh",
    label: "Odisha",
  },
  {
    id: "891",
    value: "Uchgaon",
    label: "Maharashtra",
  },
  {
    id: "892",
    value: "Mokokchung",
    label: "Nagaland",
  },
  {
    id: "893",
    value: "Paschim Punropara",
    label: "West Bengal",
  },
  {
    id: "894",
    value: "Sagwara",
    label: "Rajasthan",
  },
  {
    id: "895",
    value: "Ramganj Mandi",
    label: "Rajasthan",
  },
  {
    id: "896",
    value: "Tarakeswar",
    label: "West Bengal",
  },
  {
    id: "897",
    value: "Mahalingapura",
    label: "Karnataka",
  },
  {
    id: "898",
    value: "Dharmanagar",
    label: "Tripura",
  },
  {
    id: "899",
    value: "Mahemdabad",
    label: "Gujarat",
  },
  {
    id: "900",
    value: "Manendragarh",
    label: "Chhattisgarh",
  },
  {
    id: "901",
    value: "Uran",
    label: "Maharashtra",
  },
  {
    id: "902",
    value: "Tharamangalam",
    label: "Tamil Nadu",
  },
  {
    id: "903",
    value: "Tirukkoyilur",
    label: "Tamil Nadu",
  },
  {
    id: "904",
    value: "Pen",
    label: "Maharashtra",
  },
  {
    id: "905",
    value: "Makhdumpur",
    label: "Bihar",
  },
  {
    id: "906",
    value: "Maner",
    label: "Bihar",
  },
  {
    id: "907",
    value: "Oddanchatram",
    label: "Tamil Nadu",
  },
  {
    id: "908",
    value: "Palladam",
    label: "Tamil Nadu",
  },
  {
    id: "909",
    value: "Mundi",
    label: "Madhya Pradesh",
  },
  {
    id: "910",
    value: "Nabarangapur",
    label: "Odisha",
  },
  {
    id: "911",
    value: "Mudalagi",
    label: "Karnataka",
  },
  {
    id: "912",
    value: "Samalkha",
    label: "Haryana",
  },
  {
    id: "913",
    value: "Nepanagar",
    label: "Madhya Pradesh",
  },
  {
    id: "914",
    value: "Karjat",
    label: "Maharashtra",
  },
  {
    id: "915",
    value: "Ranavav",
    label: "Gujarat",
  },
  {
    id: "916",
    value: "Pedana",
    label: "Andhra Pradesh",
  },
  {
    id: "917",
    value: "Pinjore",
    label: "Haryana",
  },
  {
    id: "918",
    value: "Lakheri",
    label: "Rajasthan",
  },
  {
    id: "919",
    value: "Pasan",
    label: "Madhya Pradesh",
  },
  {
    id: "920",
    value: "Puttur",
    label: "Andhra Pradesh",
  },
  {
    id: "921",
    value: "Vadakkuvalliyur",
    label: "Tamil Nadu",
  },
  {
    id: "922",
    value: "Tirukalukundram",
    label: "Tamil Nadu",
  },
  {
    id: "923",
    value: "Mahidpur",
    label: "Madhya Pradesh",
  },
  {
    id: "924",
    value: "Mussoorie",
    label: "Uttarakhand",
  },
  {
    id: "925",
    value: "Muvattupuzha",
    label: "Kerala",
  },
  {
    id: "926",
    value: "Rasra",
    label: "Uttar Pradesh",
  },
  {
    id: "927",
    value: "Udaipurwati",
    label: "Rajasthan",
  },
  {
    id: "928",
    value: "Manwath",
    label: "Maharashtra",
  },
  {
    id: "929",
    value: "Adoor",
    label: "Kerala",
  },
  {
    id: "930",
    value: "Uthamapalayam",
    label: "Tamil Nadu",
  },
  {
    id: "931",
    value: "Partur",
    label: "Maharashtra",
  },
  {
    id: "932",
    value: "Nahan",
    label: "Himachal Pradesh",
  },
  {
    id: "933",
    value: "Ladwa",
    label: "Haryana",
  },
  {
    id: "934",
    value: "Mankachar",
    label: "Assam",
  },
  {
    id: "935",
    value: "Nongstoin",
    label: "Meghalaya",
  },
  {
    id: "936",
    value: "Losal",
    label: "Rajasthan",
  },
  {
    id: "937",
    value: "Sri Madhopur",
    label: "Rajasthan",
  },
  {
    id: "938",
    value: "Ramngarh",
    label: "Rajasthan",
  },
  {
    id: "939",
    value: "Mavelikkara",
    label: "Kerala",
  },
  {
    id: "940",
    value: "Rawatsar",
    label: "Rajasthan",
  },
  {
    id: "941",
    value: "Rajakhera",
    label: "Rajasthan",
  },
  {
    id: "942",
    value: "Lar",
    label: "Uttar Pradesh",
  },
  {
    id: "943",
    value: "Lal Gopalganj Nindaura",
    label: "Uttar Pradesh",
  },
  {
    id: "944",
    value: "Muddebihal",
    label: "Karnataka",
  },
  {
    id: "945",
    value: "Sirsaganj",
    label: "Uttar Pradesh",
  },
  {
    id: "946",
    value: "Shahpura",
    label: "Rajasthan",
  },
  {
    id: "947",
    value: "Surandai",
    label: "Tamil Nadu",
  },
  {
    id: "948",
    value: "Sangole",
    label: "Maharashtra",
  },
  {
    id: "949",
    value: "Pavagada",
    label: "Karnataka",
  },
  {
    id: "950",
    value: "Tharad",
    label: "Gujarat",
  },
  {
    id: "951",
    value: "Mansa",
    label: "Gujarat",
  },
  {
    id: "952",
    value: "Umbergaon",
    label: "Gujarat",
  },
  {
    id: "953",
    value: "Mavoor",
    label: "Kerala",
  },
  {
    id: "954",
    value: "Nalbari",
    label: "Assam",
  },
  {
    id: "955",
    value: "Talaja",
    label: "Gujarat",
  },
  {
    id: "956",
    value: "Malur",
    label: "Karnataka",
  },
  {
    id: "957",
    value: "Mangrulpir",
    label: "Maharashtra",
  },
  {
    id: "958",
    value: "Soro",
    label: "Odisha",
  },
  {
    id: "959",
    value: "Shahpura",
    label: "Rajasthan",
  },
  {
    id: "960",
    value: "Vadnagar",
    label: "Gujarat",
  },
  {
    id: "961",
    value: "Raisinghnagar",
    label: "Rajasthan",
  },
  {
    id: "962",
    value: "Sindhagi",
    label: "Karnataka",
  },
  {
    id: "963",
    value: "Sanduru",
    label: "Karnataka",
  },
  {
    id: "964",
    value: "Sohna",
    label: "Haryana",
  },
  {
    id: "965",
    value: "Manavadar",
    label: "Gujarat",
  },
  {
    id: "966",
    value: "Pihani",
    label: "Uttar Pradesh",
  },
  {
    id: "967",
    value: "Safidon",
    label: "Haryana",
  },
  {
    id: "968",
    value: "Risod",
    label: "Maharashtra",
  },
  {
    id: "969",
    value: "Rosera",
    label: "Bihar",
  },
  {
    id: "970",
    value: "Sankari",
    label: "Tamil Nadu",
  },
  {
    id: "971",
    value: "Malpura",
    label: "Rajasthan",
  },
  {
    id: "972",
    value: "Sonamukhi",
    label: "West Bengal",
  },
  {
    id: "973",
    value: "Shamsabad, Agra",
    label: "Uttar Pradesh",
  },
  {
    id: "974",
    value: "Nokha",
    label: "Bihar",
  },
  {
    id: "975",
    value: "PandUrban Agglomeration",
    label: "West Bengal",
  },
  {
    id: "976",
    value: "Mainaguri",
    label: "West Bengal",
  },
  {
    id: "977",
    value: "Afzalpur",
    label: "Karnataka",
  },
  {
    id: "978",
    value: "Shirur",
    label: "Maharashtra",
  },
  {
    id: "979",
    value: "Salaya",
    label: "Gujarat",
  },
  {
    id: "980",
    value: "Shenkottai",
    label: "Tamil Nadu",
  },
  {
    id: "981",
    value: "Pratapgarh",
    label: "Tripura",
  },
  {
    id: "982",
    value: "Vadipatti",
    label: "Tamil Nadu",
  },
  {
    id: "983",
    value: "Nagarkurnool",
    label: "Telangana",
  },
  {
    id: "984",
    value: "Savner",
    label: "Maharashtra",
  },
  {
    id: "985",
    value: "Sasvad",
    label: "Maharashtra",
  },
  {
    id: "986",
    value: "Rudrapur",
    label: "Uttar Pradesh",
  },
  {
    id: "987",
    value: "Soron",
    label: "Uttar Pradesh",
  },
  {
    id: "988",
    value: "Sholingur",
    label: "Tamil Nadu",
  },
  {
    id: "989",
    value: "Pandharkaoda",
    label: "Maharashtra",
  },
  {
    id: "990",
    value: "Perumbavoor",
    label: "Kerala",
  },
  {
    id: "991",
    value: "Maddur",
    label: "Karnataka",
  },
  {
    id: "992",
    value: "Nadbai",
    label: "Rajasthan",
  },
  {
    id: "993",
    value: "Talode",
    label: "Maharashtra",
  },
  {
    id: "994",
    value: "Shrigonda",
    label: "Maharashtra",
  },
  {
    id: "995",
    value: "Madhugiri",
    label: "Karnataka",
  },
  {
    id: "996",
    value: "Tekkalakote",
    label: "Karnataka",
  },
  {
    id: "997",
    value: "Seoni-Malwa",
    label: "Madhya Pradesh",
  },
  {
    id: "998",
    value: "Shirdi",
    label: "Maharashtra",
  },
  {
    id: "999",
    value: "SUrban Agglomerationr",
    label: "Uttar Pradesh",
  },
  {
    id: "1000",
    value: "Terdal",
    label: "Karnataka",
  },
  {
    id: "1001",
    value: "Raver",
    label: "Maharashtra",
  },
  {
    id: "1002",
    value: "Tirupathur",
    label: "Tamil Nadu",
  },
  {
    id: "1003",
    value: "Taraori",
    label: "Haryana",
  },
  {
    id: "1004",
    value: "Mukhed",
    label: "Maharashtra",
  },
  {
    id: "1005",
    value: "Manachanallur",
    label: "Tamil Nadu",
  },
  {
    id: "1006",
    value: "Rehli",
    label: "Madhya Pradesh",
  },
  {
    id: "1007",
    value: "Sanchore",
    label: "Rajasthan",
  },
  {
    id: "1008",
    value: "Rajura",
    label: "Maharashtra",
  },
  {
    id: "1009",
    value: "Piro",
    label: "Bihar",
  },
  {
    id: "1010",
    value: "Mudabidri",
    label: "Karnataka",
  },
  {
    id: "1011",
    value: "Vadgaon Kasba",
    label: "Maharashtra",
  },
  {
    id: "1012",
    value: "Nagar",
    label: "Rajasthan",
  },
  {
    id: "1013",
    value: "Vijapur",
    label: "Gujarat",
  },
  {
    id: "1014",
    value: "Viswanatham",
    label: "Tamil Nadu",
  },
  {
    id: "1015",
    value: "Polur",
    label: "Tamil Nadu",
  },
  {
    id: "1016",
    value: "Panagudi",
    label: "Tamil Nadu",
  },
  {
    id: "1017",
    value: "Manawar",
    label: "Madhya Pradesh",
  },
  {
    id: "1018",
    value: "Tehri",
    label: "Uttarakhand",
  },
  {
    id: "1019",
    value: "Samdhan",
    label: "Uttar Pradesh",
  },
  {
    id: "1020",
    value: "Pardi",
    label: "Gujarat",
  },
  {
    id: "1021",
    value: "Rahatgarh",
    label: "Madhya Pradesh",
  },
  {
    id: "1022",
    value: "Panagar",
    label: "Madhya Pradesh",
  },
  {
    id: "1023",
    value: "Uthiramerur",
    label: "Tamil Nadu",
  },
  {
    id: "1024",
    value: "Tirora",
    label: "Maharashtra",
  },
  {
    id: "1025",
    value: "Rangia",
    label: "Assam",
  },
  {
    id: "1026",
    value: "Sahjanwa",
    label: "Uttar Pradesh",
  },
  {
    id: "1027",
    value: "Wara Seoni",
    label: "Madhya Pradesh",
  },
  {
    id: "1028",
    value: "Magadi",
    label: "Karnataka",
  },
  {
    id: "1029",
    value: "Rajgarh (Alwar)",
    label: "Rajasthan",
  },
  {
    id: "1030",
    value: "Rafiganj",
    label: "Bihar",
  },
  {
    id: "1031",
    value: "Tarana",
    label: "Madhya Pradesh",
  },
  {
    id: "1032",
    value: "Rampur Maniharan",
    label: "Uttar Pradesh",
  },
  {
    id: "1033",
    value: "Sheoganj",
    label: "Rajasthan",
  },
  {
    id: "1034",
    value: "Raikot",
    label: "Punjab",
  },
  {
    id: "1035",
    value: "Pauri",
    label: "Uttarakhand",
  },
  {
    id: "1036",
    value: "Sumerpur",
    label: "Uttar Pradesh",
  },
  {
    id: "1037",
    value: "Navalgund",
    label: "Karnataka",
  },
  {
    id: "1038",
    value: "Shahganj",
    label: "Uttar Pradesh",
  },
  {
    id: "1039",
    value: "Marhaura",
    label: "Bihar",
  },
  {
    id: "1040",
    value: "Tulsipur",
    label: "Uttar Pradesh",
  },
  {
    id: "1041",
    value: "Sadri",
    label: "Rajasthan",
  },
  {
    id: "1042",
    value: "Thiruthuraipoondi",
    label: "Tamil Nadu",
  },
  {
    id: "1043",
    value: "Shiggaon",
    label: "Karnataka",
  },
  {
    id: "1044",
    value: "Pallapatti",
    label: "Tamil Nadu",
  },
  {
    id: "1045",
    value: "Mahendragarh",
    label: "Haryana",
  },
  {
    id: "1046",
    value: "Sausar",
    label: "Madhya Pradesh",
  },
  {
    id: "1047",
    value: "Ponneri",
    label: "Tamil Nadu",
  },
  {
    id: "1048",
    value: "Mahad",
    label: "Maharashtra",
  },
  {
    id: "1049",
    value: "Lohardaga",
    label: "Jharkhand",
  },
  {
    id: "1050",
    value: "Tirwaganj",
    label: "Uttar Pradesh",
  },
  {
    id: "1051",
    value: "Margherita",
    label: "Assam",
  },
  {
    id: "1052",
    value: "Sundarnagar",
    label: "Himachal Pradesh",
  },
  {
    id: "1053",
    value: "Rajgarh",
    label: "Madhya Pradesh",
  },
  {
    id: "1054",
    value: "Mangaldoi",
    label: "Assam",
  },
  {
    id: "1055",
    value: "Renigunta",
    label: "Andhra Pradesh",
  },
  {
    id: "1056",
    value: "Longowal",
    label: "Punjab",
  },
  {
    id: "1057",
    value: "Ratia",
    label: "Haryana",
  },
  {
    id: "1058",
    value: "Lalgudi",
    label: "Tamil Nadu",
  },
  {
    id: "1059",
    value: "Shrirangapattana",
    label: "Karnataka",
  },
  {
    id: "1060",
    value: "Niwari",
    label: "Madhya Pradesh",
  },
  {
    id: "1061",
    value: "Natham",
    label: "Tamil Nadu",
  },
  {
    id: "1062",
    value: "Unnamalaikadai",
    label: "Tamil Nadu",
  },
  {
    id: "1063",
    value: "PurqUrban Agglomerationzi",
    label: "Uttar Pradesh",
  },
  {
    id: "1064",
    value: "Shamsabad, Farrukhabad",
    label: "Uttar Pradesh",
  },
  {
    id: "1065",
    value: "Mirganj",
    label: "Bihar",
  },
  {
    id: "1066",
    value: "Todaraisingh",
    label: "Rajasthan",
  },
  {
    id: "1067",
    value: "Warhapur",
    label: "Uttar Pradesh",
  },
  {
    id: "1068",
    value: "Rajam",
    label: "Andhra Pradesh",
  },
  {
    id: "1069",
    value: "Urmar Tanda",
    label: "Punjab",
  },
  {
    id: "1070",
    value: "Lonar",
    label: "Maharashtra",
  },
  {
    id: "1071",
    value: "Powayan",
    label: "Uttar Pradesh",
  },
  {
    id: "1072",
    value: "P.N.Patti",
    label: "Tamil Nadu",
  },
  {
    id: "1073",
    value: "Palampur",
    label: "Himachal Pradesh",
  },
  {
    id: "1074",
    value: "Srisailam Project (Right Flank Colony) Township",
    label: "Andhra Pradesh",
  },
  {
    id: "1075",
    value: "Sindagi",
    label: "Karnataka",
  },
  {
    id: "1076",
    value: "Sandi",
    label: "Uttar Pradesh",
  },
  {
    id: "1077",
    value: "Vaikom",
    label: "Kerala",
  },
  {
    id: "1078",
    value: "Malda",
    label: "West Bengal",
  },
  {
    id: "1079",
    value: "Tharangambadi",
    label: "Tamil Nadu",
  },
  {
    id: "1080",
    value: "Sakaleshapura",
    label: "Karnataka",
  },
  {
    id: "1081",
    value: "Lalganj",
    label: "Bihar",
  },
  {
    id: "1082",
    value: "Malkangiri",
    label: "Odisha",
  },
  {
    id: "1083",
    value: "Rapar",
    label: "Gujarat",
  },
  {
    id: "1084",
    value: "Mauganj",
    label: "Madhya Pradesh",
  },
  {
    id: "1085",
    value: "Todabhim",
    label: "Rajasthan",
  },
  {
    id: "1086",
    value: "Srinivaspur",
    label: "Karnataka",
  },
  {
    id: "1087",
    value: "Murliganj",
    label: "Bihar",
  },
  {
    id: "1088",
    value: "Reengus",
    label: "Rajasthan",
  },
  {
    id: "1089",
    value: "Sawantwadi",
    label: "Maharashtra",
  },
  {
    id: "1090",
    value: "Tittakudi",
    label: "Tamil Nadu",
  },
  {
    id: "1091",
    value: "Lilong",
    label: "Manipur",
  },
  {
    id: "1092",
    value: "Rajaldesar",
    label: "Rajasthan",
  },
  {
    id: "1093",
    value: "Pathardi",
    label: "Maharashtra",
  },
  {
    id: "1094",
    value: "Achhnera",
    label: "Uttar Pradesh",
  },
  {
    id: "1095",
    value: "Pacode",
    label: "Tamil Nadu",
  },
  {
    id: "1096",
    value: "Naraura",
    label: "Uttar Pradesh",
  },
  {
    id: "1097",
    value: "Nakur",
    label: "Uttar Pradesh",
  },
  {
    id: "1098",
    value: "Palai",
    label: "Kerala",
  },
  {
    id: "1099",
    value: "Morinda, India",
    label: "Punjab",
  },
  {
    id: "1100",
    value: "Manasa",
    label: "Madhya Pradesh",
  },
  {
    id: "1101",
    value: "Nainpur",
    label: "Madhya Pradesh",
  },
  {
    id: "1102",
    value: "Sahaspur",
    label: "Uttar Pradesh",
  },
  {
    id: "1103",
    value: "Pauni",
    label: "Maharashtra",
  },
  {
    id: "1104",
    value: "Prithvipur",
    label: "Madhya Pradesh",
  },
  {
    id: "1105",
    value: "Ramtek",
    label: "Maharashtra",
  },
  {
    id: "1106",
    value: "Silapathar",
    label: "Assam",
  },
  {
    id: "1107",
    value: "Songadh",
    label: "Gujarat",
  },
  {
    id: "1108",
    value: "Safipur",
    label: "Uttar Pradesh",
  },
  {
    id: "1109",
    value: "Sohagpur",
    label: "Madhya Pradesh",
  },
  {
    id: "1110",
    value: "Mul",
    label: "Maharashtra",
  },
  {
    id: "1111",
    value: "Sadulshahar",
    label: "Rajasthan",
  },
  {
    id: "1112",
    value: "Phillaur",
    label: "Punjab",
  },
  {
    id: "1113",
    value: "Sambhar",
    label: "Rajasthan",
  },
  {
    id: "1114",
    value: "Prantij",
    label: "Rajasthan",
  },
  {
    id: "1115",
    value: "Nagla",
    label: "Uttarakhand",
  },
  {
    id: "1116",
    value: "Pattran",
    label: "Punjab",
  },
  {
    id: "1117",
    value: "Mount Abu",
    label: "Rajasthan",
  },
  {
    id: "1118",
    value: "Reoti",
    label: "Uttar Pradesh",
  },
  {
    id: "1119",
    value: "Tenu dam-cum-Kathhara",
    label: "Jharkhand",
  },
  {
    id: "1120",
    value: "Panchla",
    label: "West Bengal",
  },
  {
    id: "1121",
    value: "Sitarganj",
    label: "Uttarakhand",
  },
  {
    id: "1122",
    value: "Pasighat",
    label: "Arunachal Pradesh",
  },
  {
    id: "1123",
    value: "Motipur",
    label: "Bihar",
  },
  {
    id: "1124",
    value: "O' Valley",
    label: "Tamil Nadu",
  },
  {
    id: "1125",
    value: "Raghunathpur",
    label: "West Bengal",
  },
  {
    id: "1126",
    value: "Suriyampalayam",
    label: "Tamil Nadu",
  },
  {
    id: "1127",
    value: "Qadian",
    label: "Punjab",
  },
  {
    id: "1128",
    value: "Rairangpur",
    label: "Odisha",
  },
  {
    id: "1129",
    value: "Silvassa",
    label: "Dadra and Nagar Haveli",
  },
  {
    id: "1130",
    value: "Nowrozabad (Khodargama)",
    label: "Madhya Pradesh",
  },
  {
    id: "1131",
    value: "Mangrol",
    label: "Rajasthan",
  },
  {
    id: "1132",
    value: "Soyagaon",
    label: "Maharashtra",
  },
  {
    id: "1133",
    value: "Sujanpur",
    label: "Punjab",
  },
  {
    id: "1134",
    value: "Manihari",
    label: "Bihar",
  },
  {
    id: "1135",
    value: "Sikanderpur",
    label: "Uttar Pradesh",
  },
  {
    id: "1136",
    value: "Mangalvedhe",
    label: "Maharashtra",
  },
  {
    id: "1137",
    value: "Phulera",
    label: "Rajasthan",
  },
  {
    id: "1138",
    value: "Ron",
    label: "Karnataka",
  },
  {
    id: "1139",
    value: "Sholavandan",
    label: "Tamil Nadu",
  },
  {
    id: "1140",
    value: "Saidpur",
    label: "Uttar Pradesh",
  },
  {
    id: "1141",
    value: "Shamgarh",
    label: "Madhya Pradesh",
  },
  {
    id: "1142",
    value: "Thammampatti",
    label: "Tamil Nadu",
  },
  {
    id: "1143",
    value: "Maharajpur",
    label: "Madhya Pradesh",
  },
  {
    id: "1144",
    value: "Multai",
    label: "Madhya Pradesh",
  },
  {
    id: "1145",
    value: "Mukerian",
    label: "Punjab",
  },
  {
    id: "1146",
    value: "Sirsi",
    label: "Uttar Pradesh",
  },
  {
    id: "1147",
    value: "Purwa",
    label: "Uttar Pradesh",
  },
  {
    id: "1148",
    value: "Sheohar",
    label: "Bihar",
  },
  {
    id: "1149",
    value: "Namagiripettai",
    label: "Tamil Nadu",
  },
  {
    id: "1150",
    value: "Parasi",
    label: "Uttar Pradesh",
  },
  {
    id: "1151",
    value: "Lathi",
    label: "Gujarat",
  },
  {
    id: "1152",
    value: "Lalganj",
    label: "Uttar Pradesh",
  },
  {
    id: "1153",
    value: "Narkhed",
    label: "Maharashtra",
  },
  {
    id: "1154",
    value: "Mathabhanga",
    label: "West Bengal",
  },
  {
    id: "1155",
    value: "Shendurjana",
    label: "Maharashtra",
  },
  {
    id: "1156",
    value: "Peravurani",
    label: "Tamil Nadu",
  },
  {
    id: "1157",
    value: "Mariani",
    label: "Assam",
  },
  {
    id: "1158",
    value: "Phulpur",
    label: "Uttar Pradesh",
  },
  {
    id: "1159",
    value: "Rania",
    label: "Haryana",
  },
  {
    id: "1160",
    value: "Pali",
    label: "Madhya Pradesh",
  },
  {
    id: "1161",
    value: "Pachore",
    label: "Madhya Pradesh",
  },
  {
    id: "1162",
    value: "Parangipettai",
    label: "Tamil Nadu",
  },
  {
    id: "1163",
    value: "Pudupattinam",
    label: "Tamil Nadu",
  },
  {
    id: "1164",
    value: "Panniyannur",
    label: "Kerala",
  },
  {
    id: "1165",
    value: "Maharajganj",
    label: "Bihar",
  },
  {
    id: "1166",
    value: "Rau",
    label: "Madhya Pradesh",
  },
  {
    id: "1167",
    value: "Monoharpur",
    label: "West Bengal",
  },
  {
    id: "1168",
    value: "Mandawa",
    label: "Rajasthan",
  },
  {
    id: "1169",
    value: "Marigaon",
    label: "Assam",
  },
  {
    id: "1170",
    value: "Pallikonda",
    label: "Tamil Nadu",
  },
  {
    id: "1171",
    value: "Pindwara",
    label: "Rajasthan",
  },
  {
    id: "1172",
    value: "Shishgarh",
    label: "Uttar Pradesh",
  },
  {
    id: "1173",
    value: "Patur",
    label: "Maharashtra",
  },
  {
    id: "1174",
    value: "Mayang Imphal",
    label: "Manipur",
  },
  {
    id: "1175",
    value: "Mhowgaon",
    label: "Madhya Pradesh",
  },
  {
    id: "1176",
    value: "Guruvayoor",
    label: "Kerala",
  },
  {
    id: "1177",
    value: "Mhaswad",
    label: "Maharashtra",
  },
  {
    id: "1178",
    value: "Sahawar",
    label: "Uttar Pradesh",
  },
  {
    id: "1179",
    value: "Sivagiri",
    label: "Tamil Nadu",
  },
  {
    id: "1180",
    value: "Mundargi",
    label: "Karnataka",
  },
  {
    id: "1181",
    value: "Punjaipugalur",
    label: "Tamil Nadu",
  },
  {
    id: "1182",
    value: "Kailasahar",
    label: "Tripura",
  },
  {
    id: "1183",
    value: "Samthar",
    label: "Uttar Pradesh",
  },
  {
    id: "1184",
    value: "Sakti",
    label: "Chhattisgarh",
  },
  {
    id: "1185",
    value: "Sadalagi",
    label: "Karnataka",
  },
  {
    id: "1186",
    value: "Silao",
    label: "Bihar",
  },
  {
    id: "1187",
    value: "Mandalgarh",
    label: "Rajasthan",
  },
  {
    id: "1188",
    value: "Loha",
    label: "Maharashtra",
  },
  {
    id: "1189",
    value: "Pukhrayan",
    label: "Uttar Pradesh",
  },
  {
    id: "1190",
    value: "Padmanabhapuram",
    label: "Tamil Nadu",
  },
  {
    id: "1191",
    value: "Belonia",
    label: "Tripura",
  },
  {
    id: "1192",
    value: "Saiha",
    label: "Mizoram",
  },
  {
    id: "1193",
    value: "Srirampore",
    label: "West Bengal",
  },
  {
    id: "1194",
    value: "Talwara",
    label: "Punjab",
  },
  {
    id: "1195",
    value: "Puthuppally",
    label: "Kerala",
  },
  {
    id: "1196",
    value: "Khowai",
    label: "Tripura",
  },
  {
    id: "1197",
    value: "Vijaypur",
    label: "Madhya Pradesh",
  },
  {
    id: "1198",
    value: "Takhatgarh",
    label: "Rajasthan",
  },
  {
    id: "1199",
    value: "Thirupuvanam",
    label: "Tamil Nadu",
  },
  {
    id: "1200",
    value: "Adra",
    label: "West Bengal",
  },
  {
    id: "1201",
    value: "Piriyapatna",
    label: "Karnataka",
  },
  {
    id: "1202",
    value: "Obra",
    label: "Uttar Pradesh",
  },
  {
    id: "1203",
    value: "Adalaj",
    label: "Gujarat",
  },
  {
    id: "1204",
    value: "Nandgaon",
    label: "Maharashtra",
  },
  {
    id: "1205",
    value: "Barh",
    label: "Bihar",
  },
  {
    id: "1206",
    value: "Chhapra",
    label: "Gujarat",
  },
  {
    id: "1207",
    value: "Panamattom",
    label: "Kerala",
  },
  {
    id: "1208",
    value: "Niwai",
    label: "Uttar Pradesh",
  },
  {
    id: "1209",
    value: "Bageshwar",
    label: "Uttarakhand",
  },
  {
    id: "1210",
    value: "Tarbha",
    label: "Odisha",
  },
  {
    id: "1211",
    value: "Adyar",
    label: "Karnataka",
  },
  {
    id: "1212",
    value: "Narsinghgarh",
    label: "Madhya Pradesh",
  },
  {
    id: "1213",
    value: "Warud",
    label: "Maharashtra",
  },
  {
    id: "1214",
    value: "Asarganj",
    label: "Bihar",
  },
  {
    id: "1215",
    value: "Sarsod",
    label: "Haryana",
  },
  {
    id: "1216",
    value: "Gandhinagar",
    label: "Gujarat",
  },
  {
    id: "1217",
    value: "Kullu",
    label: "Himachal Pradesh",
  },
  {
    id: "1218",
    value: "Manali",
    label: "Himachal Praddesh",
  },
  {
    id: "1219",
    value: "Mirzapur",
    label: "Uttar Pradesh",
  },
  {
    id: "1220",
    value: "Kota",
    label: "Rajasthan",
  },
  {
    id: "1221",
    value: "Dispur",
    label: "Assam",
  },
];
